<!--
 * @Author: Scarlett Xiao
 * @Date: 2022-01-04 15:05:32
 * @LastEditors: dong
 * @LastEditTime: 2026-01-26 09:50:15
-->
<template>
  <!-- 育苗 -->
  <div class="content-wrap">
    <!-- 内容盒子 -->
    <OverviewTab>
      <div class="content-box">
        <!-- 左边 -->
        <div>
          <div class="sub-box">
            <span class="big-title">
              <span @click="isShowChartClick('annalsTargetInfo', 'chart')">年度经营目标完成情况</span>
              <RouteTarget class="title-right" :pathName="'ym-annals-target'">
                <span>查看更多<i class="iconfont icon-a-PresidentDesktop-Viewmore"></i></span>
              </RouteTarget>
            </span>
            <!-- 图表 -->
            <div class="chart-content">
              <div class="sub-titles">
                <span v-for="(item, i) in annalsTargetCategory" :key="i" v-bind:class="{
                  'sub-active': annalsTarget.searchType == item.id,
                }" @click="
  (annalsTarget.searchType = item.id),
  annalsTargetInfo(item.id)
">{{ item.name }}</span>
              </div>
              <div class="chart-empty" id="chart-annals-target" style="height: 100%; width: 100%"></div>
            </div>
          </div>
          <div class="sub-box">
            <span class="big-title">
              <span @click="isShowChartClick('putInfo', 'chart')">投放概览</span>
              <RouteTarget class="title-right" :pathName="'ym-put'">
                <span>查看更多<i class="iconfont icon-a-PresidentDesktop-Viewmore"></i></span>
              </RouteTarget>
            </span>
            <!-- 图表 -->
            <div class="chart-content">
              <div class="sub-titles">
                <span v-for="(item, i) in putCategory" v-bind:class="{ 'sub-active': put.searchType == item.id }"
                  @click="(put.searchType = item.id), putInfo(item.id)">{{ item.name }}</span>
              </div>
              <div class="chart-empty" id="chart-put" style="height: 100%; width: 100%"></div>
            </div>
          </div>
          <div class="sub-box">
            <span class="big-title">
              <span @click="isShowChartClick('storageInfo', 'chart')">存塘概览</span>
              <RouteTarget class="title-right" :pathName="'ym-overage'" :yearNeed="this.date">
                <span>查看更多<i class="iconfont icon-a-PresidentDesktop-Viewmore"></i></span>
              </RouteTarget>
            </span>
            <!-- 图表 -->
            <div class="chart-content">
              <div class="sub-titles">
                <span v-for="(item, i) in storageCategory" v-bind:class="{ 'sub-active': storage.searchType == item.id }"
                  @click="(storage.searchType = item.id), storageInfo(item.id)">{{ item.name }}</span>
              </div>
              <div class="chart-empty" id="chart-storage" style="height: 100%; width: 100%"></div>
            </div>
          </div>
        </div>
        <!-- 中间 -->
        <div>
          <div class="num-box">
            <span>
              <CountIn :startVal="0" :endVal="totalData.saleAmount" :speed="500" :decimals="0"
                :isReverse="totalData.saleAmount >= 0 ? false : true" />
              <span class="count-txt">销售产值/万元</span>
            </span>
            <span>
              <CountIn :startVal="0" :endVal="totalData.harvestYield" :speed="500" :decimals="0"
                :isReverse="totalData.harvestYield >= 0 ? false : true" />
              <span class="count-txt">收获产量/万尾</span>
            </span>
            <span>
              <CountIn :startVal="0" :endVal="totalData.costTotal" :speed="500" :decimals="0"
                :isReverse="totalData.costTotal >= 0 ? false : true" />
              <span class="count-txt">存塘成本/万元</span>
            </span>
            <span>
              <CountIn :startVal="0" :endVal="totalData.saleProfit" :speed="500" :decimals="0"
                :isReverse="totalData.saleProfit >= 0 ? false : true" />
              <span class="count-txt">育苗利润/万元</span>
            </span>
          </div>
          <!-- 地图 -->
          <!-- <div class="sub-box sub-box-middle">
            <BaiduCustomeMap />
          </div> -->
          <div class="sub-box sub-box-middle">
            <span class="big-title">
              <span @click="isShowChartClick('salesInfo', 'chart')">销售概览</span>
              <RouteTarget class="title-right" :pathName="'ym-sales'">
                <span>查看更多<i class="iconfont icon-a-PresidentDesktop-Viewmore"></i></span>
              </RouteTarget>
            </span>
            <!-- 图表 -->
            <div class="chart-content">
              <div class="sub-titles">
                <span v-for="(item, i) in salesCategory" v-bind:class="{ 'sub-active': sales.searchType == item.id }"
                  @click="(sales.searchType = item.id), salesInfo(item.id)">{{ item.name }}</span>
              </div>
              <div class="chart-empty" id="chart-sales" style="height: 100%; width: 100%"></div>
            </div>
          </div>
          <div class="sub-box sub-box-middle">
            <span class="big-title">
              <span @click="isShowChartClick('prefixInfo', 'chart')">单位利润计划与实际比</span>
              <RouteTarget class="title-right" :pathName="'ym-profit'">
                <span>查看更多<i class="iconfont icon-a-PresidentDesktop-Viewmore"></i></span>
              </RouteTarget>
            </span>
            <!-- 图表 -->
            <div class="chart-content">
              <div class="sub-titles">
                <span v-for="(item, i) in prefixCategory" v-bind:class="{ 'sub-active': prefix.searchType == item.id }"
                  @click="(prefix.searchType = item.id), prefixInfo(item.id)">{{ item.name }}</span>
              </div>
              <div class="chart-empty" id="chart-prefix" style="height: 100%; width: 100%"></div>
            </div>
          </div>
        </div>
        <!-- 右边 -->
        <div>
          <div class="sub-box">
            <span class="big-title">
              <span @click="isShowChartClick('cost', 'chart')">成本概览</span>
              <RouteTarget class="title-right" :pathName="'ym-cost'">
                <span>查看更多<i class="iconfont icon-a-PresidentDesktop-Viewmore"></i></span>
              </RouteTarget>
            </span>
            <!-- 图表 -->
            <div class="chart-content">
              <div class="chart-empty" id="chart-cost" style="height: 100%; width: 100%"></div>
            </div>
          </div>
          <div class="sub-box">
            <span class="big-title">
              <span @click="isShowChartClick('harvestInfo', 'chart')">收获概览</span>
              <RouteTarget class="title-right" :pathName="'ym-harvest'">
                <span>查看更多<i class="iconfont icon-a-PresidentDesktop-Viewmore"></i></span>
              </RouteTarget>
            </span>
            <!-- 图表 -->
            <div class="chart-content">
              <div class="sub-titles">
                <span v-for="(item, i) in harvestCategory" v-bind:class="{ 'sub-active': harvest.searchType == item.id }"
                  @click="(harvest.searchType = item.id), harvestInfo(item.id)">{{ item.name }}</span>
              </div>
              <div class="chart-empty" id="chart-harvest" style="height: 100%; width: 100%"></div>
            </div>
          </div>
          <div class="sub-box">
            <span class="big-title">
              <span @click="isShowChartClick('quotaInfo', 'chart')">指标概览</span>
              <RouteTarget class="title-right" :pathName="'ym-quota'">
                <span>查看更多<i class="iconfont icon-a-PresidentDesktop-Viewmore"></i></span>
              </RouteTarget>
            </span>
            <!-- 图表 -->
            <div class="chart-content">
              <div class="sub-titles">
                <span v-for="(item, i) in quotaCategory" v-bind:class="{ 'sub-active': quota.searchType == item.id }"
                  @click="(quota.searchType = item.id), quotaInfo(item.id)">{{ item.name }}</span>
              </div>
              <div class="chart-empty" id="chart-quota" style="height: 100%; width: 100%"></div>
            </div>
          </div>
        </div>
      </div>
      <el-dialog width="80%" @close="isShowChartClose" class="show-chart-box" :visible.sync="isShowChart">
        <span class="show-chart-title">{{ showChart.title }}</span>
        <div class="type_btn_container">
          <span @click="isShowChartTypeClick(showChart.chartType, item.id)" v-bind:class="{
            'sub-active': showChart.searchType == item.id,
          }" :key="index" v-for="(item, index) in showChart.targetCategory">
            {{ item.name }}
          </span>
        </div>
        <div class="cancel-delete" @click="isShowChart = false"></div>
        <div class="chart-content" id="chart_vm"></div>
      </el-dialog>
    </OverviewTab>
  </div>
</template>

<script>
import OverviewTab from "@/components/pc/overview-tab.vue";
import RouteTarget from "@/components/pc/route-target.vue";
import CountIn from "@/components/pc/count-in.vue";
import BaiduCustomeMap from "@/components/pc/baidu-map/baidu-custome-map.vue";
import * as $echarts from "echarts";
import debounce from "@/utils/debounce";
import {
  annalsTargetInfo,
  putInfo,
  storageInfo,
  salesInfo,
  prefixInfo,
  costInfo,
  harvestInfo,
  quotaInfo,
  totalDataInfo
} from "../../../api/president/overview";
export default {
  name: "ym",
  inject: ["app"],
  components: {
    OverviewTab,
    RouteTarget,
    CountIn,
    BaiduCustomeMap,
  },
  props: {
    date: "",
    dateType: "",
  },
  data() {
    return {
      // 放大查看图表参数对象
      showChart: {
        chartType: "",
        title: "",
        idName: "chart_vm",
        searchType: "",
        chartDom: null,
        unit: "",
        legend: [],
        series: [],
        xAxis: [],
        colors: [],
        targetCategory: [],
      },
      isShowChart: false, //放大查看图表（报表）数据
      orgId: "", // 一级机构
      type: "", // 时间类型(Y: 年, M: 年月)
      year: "", // 年份(yyyy)
      month: "", // 年月(yyyy-MM)
      breedTypeClass: "egg", // 阶段类型（egg：育苗，fish：养成）
      animationDuration: 6000, //
      annalsTargetCategory: [
        { id: "3", name: "销售产值" },
        { id: "2", name: "收获产量" },
        { id: "1", name: "投卵完成情况" },
        { id: "4", name: "养殖利润" },
      ],
      putCategory: [
        { id: "1", name: "投卵情况" },
        { id: "2", name: "排塘情况" },
      ],
      storageCategory: [
        { id: "1", name: "实时存塘量" },
        { id: "2", name: "月存塘成本" },
      ],
      salesCategory: [
        { id: "0", name: "产值" },
        { id: "1", name: "销售量" },
        { id: "2", name: "客户应收" },
      ],
      prefixCategory: [
        { id: "0", name: "成本" },
        { id: "1", name: "售价" },
        { id: "2", name: "利润" },
      ],
      harvestCategory: [
        { id: "0", name: "产量" },
        { id: "1", name: "塘口收获情况" },
      ],
      quotaCategory: [
        { id: "0", name: "成活率" },
        { id: "2", name: "每公斤卵出苗量" },
        { id: "3", name: "动保金额（万尾育苗）" },
      ],
      // 年度经营目标完成情况
      annalsTarget: {
        idName: "chart-annals-target",
        searchType: "3",
        chartDom: null,
        unit: "",
        legend: [],
        series: [],
        xAxis: [],
      },
      // 投放概览
      put: {
        idName: "chart-put",
        searchType: "1",
        chartDom: null,
        unit: "",
        legend: [],
        series: [],
        xAxis: [],
      },
      // 存塘概览
      storage: {
        idName: "chart-storage",
        searchType: "1",
        chartDom: null,
        unit: "",
        legend: [],
        series: [],
        xAxis: [],
        colors: [],
      },
      // 销售概览
      sales: {
        idName: "chart-sales",
        searchType: "0",
        chartDom: null,
        unit: "",
        legend: [],
        series: [],
        xAxis: [],
        colors: [],
      },
      // 单位利润计划与实际比
      prefix: {
        idName: "chart-prefix",
        searchType: "0",
        chartDom: null,
        unit: "",
        legend: [],
        series: [],
        xAxis: [],
        colors: [],
      },
      // 成本概览
      cost: {
        idName: "chart-cost",
        chartDom: null,
        unit: "",
        legend: [],
        series: [],
        xAxis: [],
        colors: [],
      },
      // 收获概览
      harvest: {
        idName: "chart-harvest",
        searchType: "0",
        chartDom: null,
        unit: "",
        legend: [],
        series: [],
        xAxis: [],
        colors: [],
      },
      // 指标概览
      quota: {
        idName: "chart-quota",
        searchType: "0",
        chartDom: null,
        unit: "",
        legend: [],
        series: [],
        xAxis: [],
        colors: [],
      },
      // 汇总数据
      totalData: {
        saleAmount: 0, // 销售产值
        saleProfit: 0, // 育苗利润【养成利润】
        harvestYield: 0, // 	收获产量
        costTotal: 0, // 	存塘成本
      },
      // 地图
      map: {},
    };
  },
  computed: {},
  methods: {
    // 关闭自定义formaater
    closeFormatter(option) {
      option.baseOption && option.baseOption.tooltip && option.baseOption.tooltip.trigger && delete option.baseOption.tooltip.trigger
      option.baseOption && option.baseOption.tooltip && option.baseOption.tooltip.formatter && delete option.baseOption.tooltip.formatter
      option.tooltip && option.tooltip.formatter && delete option.tooltip.formatter;
      option.tooltip && option.tooltip.trigger && delete option.tooltip.trigger;
    },
    // 大屏显示图表关闭事件
    isShowChartClose() {
      this.showChart = {
        idName: "chart_vm",
        searchType: "",
        chartDom: null,
        unit: "",
        legend: [],
        series: [],
        xAxis: [],
        colors: [],
      };
    },
    // 大屏内type切换点击事件
    isShowChartTypeClick(type, searchType) {
      this.showChart.searchType = searchType;
      if (type === "annalsTargetInfo") {
        this.annalsTargetInfo(searchType, true);
        // console.log("切换年度经营目标完成情况图表大屏");
      } else if (type === "putInfo") {
        this.putInfo(searchType, true);
        // console.log("切换投放概览图表大屏");
      } else if (type === "storageInfo") {
        this.storageInfo(searchType, true);
        // console.log("切换存塘概览图表大屏");
      } else if (type === "salesInfo") {
        this.salesInfo(searchType, true);
      } else if (type === "prefixInfo") {
        this.prefixInfo(searchType, true);
        // console.log("切换单位利润计划与实际比图表大屏");
      } else if (type === "cost") {
        // console.log("切换成本概览图表大屏");
      } else if (type === "harvestInfo") {
        this.harvestInfo(searchType, true);
        // console.log("切换收获概览图表大屏");
      } else if (type === "quotaInfo") {
        this.quotaInfo(searchType, true);
      }
    },
    // 大屏显示图表点击事件
    isShowChartClick(type, showType) {
      this.showChart.chartType = type;
      if (type === "annalsTargetInfo") {
        this.showChart.title = "年度经营目标完成情况";
        this.showChart.targetCategory = this.annalsTargetCategory;
        this.showChart.searchType = this.annalsTarget.searchType;
        this.annalsTargetInfo(this.showChart.searchType, true);
        console.log("显示年度经营目标完成情况图表大屏");
      } else if (type === "putInfo") {
        this.showChart.title = "投放概览";
        this.showChart.targetCategory = this.putCategory;
        this.showChart.searchType = this.put.searchType;
        this.putInfo(this.showChart.searchType, true);
        console.log("显示投放概览图表大屏");
      } else if (type === "storageInfo") {
        this.showChart.title = "存塘概览";
        this.showChart.targetCategory = this.storageCategory;
        this.showChart.searchType = this.storage.searchType;
        this.storageInfo(this.showChart.searchType, true);
        console.log("显示存塘概览图表大屏");
      } else if (type === "salesInfo") {
        this.showChart.title = "销售概览";
        this.showChart.targetCategory = this.salesCategory;
        this.showChart.searchType = this.sales.searchType;
        this.salesInfo(this.showChart.searchType, true);
        console.log("显示销售概览图表大屏");
      } else if (type === "prefixInfo") {
        this.showChart.title = "单位利润计划与实际比";
        this.showChart.targetCategory = this.prefixCategory;
        this.showChart.searchType = this.prefix.searchType;
        this.prefixInfo(this.showChart.searchType, true);
      } else if (type === "cost") {
        this.showChart.title = "成本概览";
        this.showChart.searchType = this.cost.searchType;
        this.showChart.legend = this.cost.legend;
        this.showChart.series = this.cost.series;
        this.showChart.xAxis = this.cost.xAxis;
        this.costChart(this.showChart, true);
        console.log("显示成本概览图表大屏");
      } else if (type === "harvestInfo") {
        this.showChart.title = "收获概览";
        this.showChart.targetCategory = this.harvestCategory;
        this.showChart.searchType = this.harvest.searchType;
        this.harvestInfo(this.showChart.searchType, true);
      } else if (type === "quotaInfo") {
        this.showChart.title = "指标概览";
        this.showChart.targetCategory = this.quotaCategory;
        this.showChart.searchType = this.quota.searchType;
        this.quotaInfo(this.showChart.searchType, true);
      }
    },
    annalsTargetChart(obj, showBol) {
      // 配置图标属性
      let option = {
        tooltip: {
          trigger: "axis",
          confine: true,
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#999",
            },
          },
          textStyle: {
            color: "#111E39",
            fontSize: 12,
            fontFamily: "Microsoft YaHei",
            fontWeight: 400,
          },
          formatter: (params) => {
            let dataStr = `<div><p style="font-weight:bold;margin:0 8px 10px;">${params[0].name}</p></div>`;
            params.forEach((item, i) => {
              if (i < 2) {
                dataStr += `<div style=${!item.data ? "display:none;" : "display:block"
                  }>
          <div style="margin: 0 8px;">
            <span style="display:inline-block;margin-right:4px;width:8px;height:8px;border-radius:2px;background:linear-gradient(0deg, ${item.color.colorStops[0].color
                  } 0%, ${item.color.colorStops[1].color} 100%);"></span>
            <span>${item.seriesName}</span>
            <span style="float:right;color:#000000;margin-left:20px;">${item.data + " " + obj.unit
                  }</span>
          </div>
        </div>`;
              } else {
                dataStr += `<div style=${!item.data ? "display:none;" : "display:block"
                  }>
          <div style="margin: 0 6px;">
            <span style="display:inline-block;position:relative;width:8px;margin-right:5px;
            ">
            <svg class="icon" style="position:absolute;top:-9px" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" width="12" height="12"><path d="M682.667 307.2c17.066 0 34.133 17.067 34.133 34.133v341.334c0 17.066-17.067 34.133-34.133 34.133H341.333c-17.066 0-34.133-17.067-34.133-34.133V341.333c0-17.066 17.067-34.133 34.133-34.133h341.334m0-136.533H341.333c-93.866 0-170.666 76.8-170.666 170.666v341.334c0 93.866 76.8 170.666 170.666 170.666h341.334c93.866 0 170.666-76.8 170.666-170.666V341.333c0-93.866-76.8-170.666-170.666-170.666z" fill="#1afa29"/></svg>
            </span>
            <span>${item.seriesName}</span>
            <span style="float:right;color:#000000;margin-left:20px;">${item.data
                  } %</span>
          </div>
        </div>`;
              }
            });
            return dataStr;
          },
        },
        grid: {
          right: 30,
          top: 30,
          bottom: 49,
          left: 30,
          width: "auto",
          containLabel: true,
        },
        legend: {
          type: "scroll",
          bottom: 10,
          left: 30,
          itemHeight: 8,
          itemGap: 40,
          itemWidth: 8,
          pageTextStyle: {
            color: "#9BA7BF",
            fontSize: 12,
            fontFamily: "SimSun",
          },
          pageIconColor: "#AAAAAA", //翻页下一页的三角按钮颜色
          pageIconInactiveColor: "#333333", //翻页按钮不激活时（即翻页到头时）的颜色。
          pageIconSize: 11, //翻页按钮大小
          data: (function () {
            let style = {
              fontSize: 12,
              fontFamily: "SimSun",
              fontWeight: 400,
              color: "#9BA7BF",
            };
            let list = [];
            obj.legend.forEach((re) => {
              if (re == "完成率") {
                list.push({
                  name: re,
                  textStyle: style,
                  icon: "path://M682.666667 588.8c17.066667 0 34.133333-17.066667 34.133333-34.133333v-341.333334c0-17.066667-17.066667-34.133333-34.133333-34.133333H341.333333c-17.066667 0-34.133333 17.066667-34.133333 34.133333V554.666667c0 17.066667 17.066667 34.133333 34.133333 34.133333h341.333334M682.666667 725.333333H341.333333c-93.866667 0-170.666667-76.8-170.666666-170.666666v-341.333334c0-93.866667 76.8-170.666667 170.666666-170.666666h341.333334c93.866667 0 170.666667 76.8 170.666666 170.666666V554.666667c0 93.866667-76.8 170.666667-170.666666 170.666666z",
                });
              } else {
                list.push({
                  name: re,
                  textStyle: style,
                  icon: "path://M682.666667 725.333333H341.333333c-93.866667 0-170.666667-76.8-170.666666-170.666666v-341.333334c0-93.866667 76.8-170.666667 170.666666-170.666666h341.333334c93.866667 0 170.666667 76.8 170.666666 170.666666V554.666667c0 93.866667-76.8 170.666667-170.666666 170.666666z",
                });
              }
            });
            return list;
          })(),
        },
        xAxis: [
          {
            type: "category",
            data: obj.xAxis,
            boundaryGap: true,
            axisPointer: {
              type: "shadow",
            },
            axisLabel: {
              interval: 0,
              margin: 10,
              textStyle: {
                fontSize: 12,
                fontFamily: "SimSun",
                fontWeight: 400,
                color: "#838DA1",
              },
            },
            axisTick: {
              // x轴刻度线
              show: false,
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#46494A",
              },
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            min: 0,
            axisLabel: {
              margin: 15,
              textStyle: {
                fontSize: 12,
                fontFamily: "SimSun",
                fontWeight: 400,
                color: "#838DA1",
              },
              formatter: "{value}",
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "#46494A",
                type: [10, 10],
                dashOffset: 5,
              },
            },
          },
          {
            type: "value",
            interval: 10,
            axisLabel: {
              margin: 10,
              textStyle: {
                fontSize: 12,
                fontFamily: "SimSun",
                fontWeight: 400,
                color: "#838DA1",
              },
              formatter: "",
            },
            splitLine: {
              show: false,
            },
          },
        ],
        series: obj.series,
      };
      if (showBol) {
        this.isShowChart = true;
        this.closeFormatter(option)
        obj.series.forEach((item) => {
          if (item.type === "bar") {
            item.barMinWidth = "16";
            // item.barMinHeight = "70";
            // item.barGap = 0;
            item.label = {
              normal: {
                show: true,
                fontSize: 12,
                color: "#ffffff",
                position: "top",
                formatter: (params) => {
                  if (params.value == 0) {
                    return ``;
                  }
                  return params.value; //随便写的值
                },
              },
            };
          } else if (item.type === "line") {
            item.symbolSize = 20;
            item.label = {
              show: true,
              fontSize: 12,
              color: item.color,
              position: "top",
              distance: "30",
              formatter: (params) => {
                return params.value + "%"; //随便写的值
              },
            };
          }
        });
        console.log(obj);
        setTimeout(() => {
          obj.chartDom && obj.chartDom.clear();
          obj.chartDom = new $echarts.init(document.getElementById(obj.idName));
          if (option && typeof option === "object") {
            obj.chartDom.setOption(option, this.animationDuration);
          }
        });
        return;
      }
      this.annalsTarget.chartDom && this.annalsTarget.chartDom.clear();
      this.annalsTarget.chartDom = new $echarts.init(
        document.getElementById(obj.idName)
      );
      if (option && typeof option === "object") {
        this.annalsTarget.chartDom.setOption(option, this.animationDuration);
      }
    },
    putChart(obj, showBol) {
      let option =
        obj.searchType == "1"
          ? {
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "cross",
                crossStyle: {
                  color: "#999",
                },
              },
              textStyle: {
                color: "#111E39",
                fontSize: 12,
                fontFamily: "Microsoft YaHei",
                fontWeight: 400,
              },
              formatter: (params) => {
                let dataStr = `<div><p style="font-weight:bold;margin:0 8px 10px;">${params[0].name}</p></div>`;
                params.forEach((item, i) => {
                  dataStr += `<div style=${!item.data ? "display:none;" : "display:block"
                    }>
          <div style="margin: 0 8px;">
            <span style="display:inline-block;margin-right:4px;width:8px;height:8px;border-radius:2px;background:linear-gradient(0deg, ${item.color.colorStops[0].color
                    } 0%, ${item.color.colorStops[1].color} 100%);"></span>
            <span>${item.seriesName}</span>
            <span style="float:right;color:#000000;margin-left:20px;">${item.data + " " + obj.unit
                    }</span>
          </div>
        </div>`;
                });
                return dataStr;
              },
            },
            grid: {
              right: 30,
              top: 30,
              bottom: 49,
              left: 30,
              width: "auto",
              containLabel: true,
            },
            legend: {
              type: "scroll",
              bottom: 10,
              left: 30,
              itemHeight: 8,
              itemGap: 40,
              itemWidth: 8,
              pageTextStyle: {
                color: "#9BA7BF",
                fontSize: 12,
                fontFamily: "SimSun",
              },
              pageIconColor: "#AAAAAA", //翻页下一页的三角按钮颜色
              pageIconInactiveColor: "#333333", //翻页按钮不激活时（即翻页到头时）的颜色。
              pageIconSize: 11, //翻页按钮大小
              data: (function () {
                let style = {
                  fontSize: 12,
                  fontFamily: "SimSun",
                  fontWeight: 400,
                  color: "#9BA7BF",
                };
                const list = [];
                obj.legend.forEach((re) => {
                  list.push({
                    name: re,
                    textStyle: style,
                    icon: "path://M682.666667 725.333333H341.333333c-93.866667 0-170.666667-76.8-170.666666-170.666666v-341.333334c0-93.866667 76.8-170.666667 170.666666-170.666666h341.333334c93.866667 0 170.666667 76.8 170.666666 170.666666V554.666667c0 93.866667-76.8 170.666667-170.666666 170.666666z",
                  });
                });
                return list;
              })(),
            },
            xAxis: [
              {
                type: "category",
                data: obj.xAxis,
                boundaryGap: true,
                axisPointer: {
                  type: "shadow",
                },
                axisLabel: {
                  interval: 0,
                  margin: 10,
                  textStyle: {
                    fontSize: 12,
                    fontFamily: "SimSun",
                    fontWeight: 400,
                    color: "#838DA1",
                  },
                },
                axisTick: {
                  // x轴刻度线
                  show: false,
                },
                axisLine: {
                  show: true,
                  lineStyle: {
                    color: "#46494A",
                  },
                },
              },
            ],
            yAxis: [
              {
                type: "value",
                min: 0,
                axisLabel: {
                  margin: 15,
                  textStyle: {
                    fontSize: 12,
                    fontFamily: "SimSun",
                    fontWeight: 400,
                    color: "#838DA1",
                  },
                  formatter: "{value}",
                },
                splitLine: {
                  show: true,
                  lineStyle: {
                    color: "#46494A",
                    type: [10, 10],
                    dashOffset: 5,
                  },
                },
              },
            ],
            series: obj.series,
          }
          : {
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "cross",
                crossStyle: {
                  color: "#999",
                },
              },
              textStyle: {
                color: "#111E39",
                fontSize: 12,
                fontFamily: "Microsoft YaHei",
                fontWeight: 400,
              },
              formatter: (params) => {
                let dataStr = `<div><p style="font-weight:bold;margin:0 8px 10px;">${params[0].name}</p></div>`;
                params.forEach((item, i) => {
                  if (item.seriesName != "排塘率") {
                    dataStr += `<div style=${!item.data ? "display:none;" : "display:block"
                      }>
          <div style="margin: 0 8px;">
            <span style="display:inline-block;margin-right:4px;width:8px;height:8px;border-radius:2px;background:linear-gradient(0deg, ${item.color.colorStops[0].color
                      } 0%, ${item.color.colorStops[1].color} 100%);"></span>
            <span>${item.seriesName}</span>
            <span style="float:right;color:#000000;margin-left:20px;">${item.data + " " + obj.unit
                      }</span>
          </div>
        </div>`;
                  } else {
                    dataStr += `<div style=${!item.data ? "display:none;" : "display:block"
                      }>
          <div style="margin: 0 6px;">
            <span style="display:inline-block;position:relative;width:8px;margin-right:5px;
            ">
            <svg class="icon" style="position:absolute;top:-9px" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" width="12" height="12"><path d="M682.667 307.2c17.066 0 34.133 17.067 34.133 34.133v341.334c0 17.066-17.067 34.133-34.133 34.133H341.333c-17.066 0-34.133-17.067-34.133-34.133V341.333c0-17.066 17.067-34.133 34.133-34.133h341.334m0-136.533H341.333c-93.866 0-170.666 76.8-170.666 170.666v341.334c0 93.866 76.8 170.666 170.666 170.666h341.334c93.866 0 170.666-76.8 170.666-170.666V341.333c0-93.866-76.8-170.666-170.666-170.666z" fill="${item.color
                      }"/></svg>
            </span>
            <span>${item.seriesName}</span>
            <span style="float:right;color:#000000;margin-left:20px;">${item.data
                      }</span>
          </div>
        </div>`;
                  }
                });
                return dataStr;
              },
            },
            grid: {
              right: 30,
              top: 30,
              bottom: 49,
              left: 30,
              width: "auto",
              containLabel: true,
            },
            legend: {
              type: "scroll",
              bottom: 10,
              left: 30,
              itemHeight: 8,
              itemGap: 40,
              itemWidth: 8,
              pageTextStyle: {
                color: "#9BA7BF",
                fontSize: 12,
                fontFamily: "SimSun",
              },
              pageIconColor: "#AAAAAA", //翻页下一页的三角按钮颜色
              pageIconInactiveColor: "#333333", //翻页按钮不激活时（即翻页到头时）的颜色。
              pageIconSize: 11, //翻页按钮大小
              data: (function () {
                let style = {
                  fontSize: 12,
                  fontFamily: "SimSun",
                  fontWeight: 400,
                  color: "#9BA7BF",
                };
                let list = [];
                obj.legend.forEach((re) => {
                  if (re != "排塘率") {
                    list.push({
                      name: re,
                      textStyle: style,
                      icon: "path://M682.666667 725.333333H341.333333c-93.866667 0-170.666667-76.8-170.666666-170.666666v-341.333334c0-93.866667 76.8-170.666667 170.666666-170.666666h341.333334c93.866667 0 170.666667 76.8 170.666666 170.666666V554.666667c0 93.866667-76.8 170.666667-170.666666 170.666666z",
                    });
                  } else {
                    list.push({
                      name: re,
                      textStyle: style,
                      icon: "path://M682.666667 588.8c17.066667 0 34.133333-17.066667 34.133333-34.133333v-341.333334c0-17.066667-17.066667-34.133333-34.133333-34.133333H341.333333c-17.066667 0-34.133333 17.066667-34.133333 34.133333V554.666667c0 17.066667 17.066667 34.133333 34.133333 34.133333h341.333334M682.666667 725.333333H341.333333c-93.866667 0-170.666667-76.8-170.666666-170.666666v-341.333334c0-93.866667 76.8-170.666667 170.666666-170.666666h341.333334c93.866667 0 170.666667 76.8 170.666666 170.666666V554.666667c0 93.866667-76.8 170.666667-170.666666 170.666666z",
                    });
                  }
                });
                return list;
              })(),
            },
            xAxis: [
              {
                type: "category",
                data: obj.xAxis,
                boundaryGap: true,
                axisPointer: {
                  type: "shadow",
                },
                axisLabel: {
                  interval: 0,
                  margin: 10,
                  textStyle: {
                    fontSize: 12,
                    fontFamily: "SimSun",
                    fontWeight: 400,
                    color: "#838DA1",
                  },
                },
                axisTick: {
                  // x轴刻度线
                  show: false,
                },
                axisLine: {
                  show: true,
                  lineStyle: {
                    color: "#46494A",
                  },
                },
              },
            ],
            yAxis: [
              {
                type: "value",
                min: 0,
                axisLabel: {
                  margin: 15,
                  textStyle: {
                    fontSize: 12,
                    fontFamily: "SimSun",
                    fontWeight: 400,
                    color: "#838DA1",
                  },
                  formatter: "{value}",
                },
                splitLine: {
                  show: true,
                  lineStyle: {
                    color: "#46494A",
                    type: [10, 10],
                    dashOffset: 5,
                  },
                },
              },
              {
                type: "value",
                min: 0,
                axisLabel: {
                  margin: 10,
                  textStyle: {
                    fontSize: 12,
                    fontFamily: "SimSun",
                    fontWeight: 400,
                    color: "#838DA1",
                  },
                  formatter: "",
                },
                splitLine: {
                  show: false,
                },
              },
            ],
            series: obj.series,
          };
      if (showBol) {
        this.isShowChart = true;
        this.closeFormatter(option)
        obj.series.forEach((item) => {
          if (item.type === "bar") {
            item.barMinWidth = "10";
            item.barGap = 1;
            item.label = {
              normal: {
                show: true,
                fontSize: 12,
                color: "#ffffff",
                position: "center",
                rotate: "90",
                formatter: (params) => {
                  if (params.value == 0) {
                    return ``;
                  }
                  return params.value; //随便写的值
                },
              },
            };
          } else if (item.type === "line") {
            item.symbolSize = 20;
            item.label = {
              show: true,
              fontSize: 12,
              color: item.color,
              position: "top",
              distance: "30",
              formatter: (params) => {
                return params.value + "%"; //随便写的值
              },
            };
          }
        });
        setTimeout(() => {
          obj.chartDom && obj.chartDom.clear();
          obj.chartDom = new $echarts.init(document.getElementById(obj.idName));
          if (option && typeof option === "object") {
            obj.chartDom.setOption(option, this.animationDuration);
          }
        });
        return;
      }
      this.put.chartDom && this.put.chartDom.clear();
      this.put.chartDom = new $echarts.init(
        document.getElementById(obj.idName)
      );
      if (option && typeof option === "object") {
        this.put.chartDom.setOption(option, this.animationDuration);
      }
    },
    storageChart(obj, showBol) {
      let option =
        obj.searchType == "1"
          ? {
            baseOption: {
              backgroundColor: "#1E1E2B",
              timeline: {
                show: false,
                top: 0,
                data: [],
              },
              grid: [
                {
                  show: false,
                  left: "4%",
                  top: "5%",
                  bottom: 49,
                  containLabel: true,
                  width: "37%",
                },
                {
                  show: false,
                  left: "51%",
                  top: "5%",
                  bottom: 69,
                  width: "0%",
                },
                {
                  show: false,
                  right: "4%",
                  top: "5%",
                  bottom: 49,
                  containLabel: true,
                  width: "37.6%",
                },
              ],
              tooltip: {
                trigger: "axis",
                axisPointer: {
                  type: "cross",
                  crossStyle: {
                    color: "#999",
                  },
                  label: {
                    padding: [5, 13, 5, 13],
                  },
                },
                textStyle: {
                  color: "#111E39",
                  fontSize: 12,
                  fontFamily: "Microsoft YaHei",
                  fontWeight: 400,
                },
                formatter: (params) => {
                  let dataStr = `<div><p style="font-weight:bold;margin:0 8px 10px;">${params[0].name}</p></div>`;
                  params.forEach((item, i) => {
                    if (item.seriesName.indexOf("塘口数") > -1) {
                      dataStr += `<div style=${!item.data ? "display:none;" : "display:block"
                        }>
          <div style="margin: 0 8px;">
            <span style="display:inline-block;margin-right:4px;width:8px;height:8px;border-radius:2px;background:linear-gradient(0deg, ${item.color.colorStops[0].color
                        } 0%, ${item.color.colorStops[1].color} 100%);"></span>
            <span>${item.seriesName}</span>
            <span style="float:right;color:#000000;margin-left:20px;">${item.data
                        } 口</span>
          </div>
        </div>`;
                    } else {
                      dataStr += `<div style=${!item.data ? "display:none;" : "display:block"
                        }>
          <div style="margin: 0 8px;">
            <span style="display:inline-block;margin-right:4px;width:8px;height:8px;border-radius:2px;background:linear-gradient(0deg, ${item.color.colorStops[0].color
                        } 0%, ${item.color.colorStops[1].color} 100%);"></span>
            <span>${item.seriesName}</span>
            <span style="float:right;color:#000000;margin-left:20px;">${item.data
                        } 尾</span>
          </div>
        </div>`;
                    }
                  });
                  return dataStr;
                },
              },
              legend: {
                type: "scroll",
                bottom: 10,
                left: 30,
                itemHeight: 8,
                itemGap: 40,
                itemWidth: 8,
                pageTextStyle: {
                  color: "#9BA7BF",
                  fontSize: 12,
                  fontFamily: "SimSun",
                },
                pageIconColor: "#AAAAAA", //翻页下一页的三角按钮颜色
                pageIconInactiveColor: "#333333", //翻页按钮不激活时（即翻页到头时）的颜色。
                pageIconSize: 11, //翻页按钮大小
                data: (function () {
                  let style = {
                    fontSize: 12,
                    fontFamily: "SimSun",
                    fontWeight: 400,
                    color: "#9BA7BF",
                  };
                  const list = [];
                  obj.legend.forEach((re) => {
                    list.push({
                      name: re,
                      textStyle: style,
                      icon: "path://M682.666667 725.333333H341.333333c-93.866667 0-170.666667-76.8-170.666666-170.666666v-341.333334c0-93.866667 76.8-170.666667 170.666666-170.666666h341.333334c93.866667 0 170.666667 76.8 170.666666 170.666666V554.666667c0 93.866667-76.8 170.666667-170.666666 170.666666z",
                    });
                  });
                  return list;
                })(),
              },
              xAxis: [
                {
                  type: "value",
                  inverse: true,
                  axisLine: {
                    show: false,
                  },
                  axisTick: {
                    show: false,
                  },
                  position: "bottom",
                  axisLabel: {
                    show: true,
                    color: "#838DA1",
                    hideOverlap: true,
                  },
                  splitLine: {
                    show: true,
                    lineStyle: {
                      color: "#46494A",
                    },
                  },
                },
                {
                  gridIndex: 1,
                  show: false,
                },
                {
                  gridIndex: 2,
                  axisLine: {
                    show: false,
                  },
                  axisTick: {
                    show: false,
                  },
                  position: "bottom",
                  axisLabel: {
                    show: true,
                    color: "#838DA1",
                    hideOverlap: true,
                  },
                  splitLine: {
                    show: true,
                    lineStyle: {
                      color: "#46494A",
                    },
                  },
                },
              ],
              yAxis: [
                {
                  type: "category",
                  inverse: true,
                  position: "right",
                  boundaryGap: true,
                  axisPointer: {
                    type: "shadow",
                  },
                  axisLine: {
                    show: true,
                    lineStyle: {
                      color: "#46494A",
                    },
                  },
                  axisTick: {
                    show: false,
                  },
                  axisLabel: {
                    show: false,
                  },
                  data: obj.xAxis,
                },
                {
                  gridIndex: 1,
                  type: "category",
                  inverse: true,
                  position: "left",
                  axisLine: {
                    show: false,
                  },
                  axisTick: {
                    show: false,
                  },
                  axisLabel: {
                    show: true,
                    padding: [30, 30, 30, 30],
                    textStyle: {
                      color: "#838DA1",
                      fontSize: 12,
                    },
                    align: "center",
                  },
                  data: obj.xAxis.map(function (value) {
                    return {
                      value: value,
                      textStyle: {
                        align: "center",
                      },
                    };
                  }),
                },
                {
                  gridIndex: 2,
                  type: "category",
                  inverse: true,
                  position: "left",
                  boundaryGap: true,
                  axisPointer: {
                    type: "shadow",
                  },
                  axisLine: {
                    show: true,
                    lineStyle: {
                      color: "#46494A",
                    },
                  },
                  axisTick: {
                    show: false,
                  },
                  axisLabel: {
                    show: false,
                  },
                  data: obj.xAxis,
                },
              ],
              series: [],
            },
            options: [
              {
                series: obj.series,
              },
            ],
          }
          : {
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "cross",
                crossStyle: {
                  color: "#999",
                },
              },
              textStyle: {
                color: "#111E39",
                fontSize: 12,
                fontFamily: "Microsoft YaHei",
                fontWeight: 400,
              },
              formatter: (params) => {
                let dataStr = `<div><p style="font-weight:bold;margin:0 8px 10px;">${params[0].name}</p></div>`;
                params.forEach((item, i) => {
                  dataStr += `<div style=${!item.data ? "display:none;" : "display:block"
                    }>
          <div style="margin: 0 8px;">
            <span style="display:inline-block;margin-right:4px;width:8px;height:8px;border-radius:2px;background:linear-gradient(0deg, ${item.color.colorStops[0].color
                    } 0%, ${item.color.colorStops[1].color} 100%);"></span>
            <span>${item.seriesName}</span>
            <span style="float:right;color:#000000;margin-left:20px;">${item.data
                    } 万元</span>
          </div>
        </div>`;
                });
                return dataStr;
              },
            },
            grid: {
              right: 30,
              top: 30,
              bottom: 49,
              left: 30,
              width: "auto",
              containLabel: true,
            },
            legend: {
              type: "scroll",
              bottom: 10,
              left: 30,
              itemHeight: 8,
              itemGap: 40,
              itemWidth: 8,
              pageTextStyle: {
                color: "#9BA7BF",
                fontSize: 12,
                fontFamily: "SimSun",
              },
              pageIconColor: "#AAAAAA", //翻页下一页的三角按钮颜色
              pageIconInactiveColor: "#333333", //翻页按钮不激活时（即翻页到头时）的颜色。
              pageIconSize: 11, //翻页按钮大小
              data: (function () {
                let style = {
                  fontSize: 12,
                  fontFamily: "SimSun",
                  fontWeight: 400,
                  color: "#9BA7BF",
                };
                const list = [];
                obj.legend.forEach((re) => {
                  list.push({
                    name: re,
                    textStyle: style,
                    icon: "path://M682.666667 725.333333H341.333333c-93.866667 0-170.666667-76.8-170.666666-170.666666v-341.333334c0-93.866667 76.8-170.666667 170.666666-170.666666h341.333334c93.866667 0 170.666667 76.8 170.666666 170.666666V554.666667c0 93.866667-76.8 170.666667-170.666666 170.666666z",
                  });
                });
                return list;
              })(),
            },
            xAxis: [
              {
                type: "category",
                data: obj.xAxis,
                boundaryGap: true,
                axisPointer: {
                  type: "shadow",
                },
                axisLabel: {
                  interval: 0,
                  margin: 10,
                  textStyle: {
                    fontSize: 12,
                    fontFamily: "SimSun",
                    fontWeight: 400,
                    color: "#838DA1",
                  },
                },
                axisTick: {
                  // x轴刻度线
                  show: false,
                },
                axisLine: {
                  show: true,
                  lineStyle: {
                    color: "#46494A",
                  },
                },
              },
            ],
            yAxis: [
              {
                type: "value",
                min: 0,
                axisLabel: {
                  margin: 15,
                  textStyle: {
                    fontSize: 12,
                    fontFamily: "SimSun",
                    fontWeight: 400,
                    color: "#838DA1",
                  },
                  formatter: "{value}",
                },
                splitLine: {
                  show: true,
                  lineStyle: {
                    color: "#46494A",
                    type: [10, 10],
                    dashOffset: 5,
                  },
                },
              },
            ],
            series: obj.series,
          };
      if (showBol) {
        this.isShowChart = true;
        this.closeFormatter(option)
        setTimeout(() => {
          this.showChart.chartDom && this.showChart.chartDom.clear();
          this.showChart.chartDom = new $echarts.init(
            document.getElementById(this.showChart.idName)
          );
          if (obj.searchType == 1) {
            console.log(option);
            option.options[0].series.forEach((item) => {
              item.barMinWidth = "6";
              item.barGap = 1;
              item.label = {
                normal: {
                  show: true,
                  textStyle: {
                    color: "white",
                    fontStyle: "normal",
                    fontFamily: "微软雅黑",
                    fontSize: 10,
                  },
                  position: item.yAxisIndex ? "right" : "left",
                  // offset: [0, 0],
                  // distance: "-300",
                  // rotate: "90",
                  formatter: (param) => {
                    if (param.value == 0) {
                      return ``;
                    }
                    return param.value;
                  },
                },
              };
            });
          } else {
            option.series.forEach((item) => {
              item.barMinWidth = "10";
              item.barGap = 1;
              item.label = {
                normal: {
                  show: true,
                  position: "center",
                  textStyle: {
                    color: "white",
                    fontStyle: "normal",
                    fontFamily: "微软雅黑",
                    fontSize: 12,
                  },
                  // offset: [0, 0],
                  distance: "10",
                  rotate: "90",
                  formatter: (param) => {
                    if (param.value == 0) {
                      return ``;
                    }
                    return param.value;
                  },
                },
              };
            });
          }
          this.showChart.chartDom.setOption(option, this.animationDuration);
        });
        return;
      }
      this.storage.chartDom && this.storage.chartDom.clear();
      this.storage.chartDom = new $echarts.init(
        document.getElementById(obj.idName)
      );
      if (option && typeof option === "object") {
        this.storage.chartDom.setOption(option, this.animationDuration);
      }
    },
    salesChart(obj, showBol) {
      let option = {};
      if (obj.searchType == "0") {
        option = {
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "cross",
              crossStyle: {
                color: "#999",
              },
            },
            textStyle: {
              color: "#111E39",
              fontSize: 12,
              fontFamily: "Microsoft YaHei",
              fontWeight: 400,
            },
            formatter: (params) => {
              let dataStr = `<div><p style="font-weight:bold;margin:0 8px 10px;">${params[0].name}</p></div>`;
              params.forEach((item, i) => {
                dataStr += `<div style=${!item.data ? "display:none;" : "display:block"
                  }>
          <div style="margin: 0 8px;">
            <span style="display:inline-block;margin-right:4px;width:8px;height:8px;border-radius:2px;background:linear-gradient(0deg, ${item.color.colorStops[0].color
                  } 0%, ${item.color.colorStops[1].color} 100%);"></span>
            <span>${item.seriesName}</span>
            <span style="float:right;color:#000000;margin-left:20px;">${item.data
                  } 万元</span>
          </div>
        </div>`;
              });
              return dataStr;
            },
          },
          grid: {
            right: 30,
            top: showBol ? 60 : 25,
            bottom: 49,
            left: 30,
            width: "auto",
            containLabel: true,
          },
          legend: {
            type: "scroll",
            bottom: 10,
            left: 30,
            itemHeight: 8,
            itemGap: 40,
            itemWidth: 8,
            pageTextStyle: {
              color: "#9BA7BF",
              fontSize: 12,
              fontFamily: "SimSun",
            },
            pageIconColor: "#AAAAAA", //翻页下一页的三角按钮颜色
            pageIconInactiveColor: "#333333", //翻页按钮不激活时（即翻页到头时）的颜色。
            pageIconSize: 11, //翻页按钮大小
            data: (function () {
              let style = {
                fontSize: 12,
                fontFamily: "SimSun",
                fontWeight: 400,
                color: "#9BA7BF",
              };
              let list = [];
              obj.legend.forEach((re) => {
                list.push({
                  name: re,
                  textStyle: style,
                  icon: "path://M682.666667 725.333333H341.333333c-93.866667 0-170.666667-76.8-170.666666-170.666666v-341.333334c0-93.866667 76.8-170.666667 170.666666-170.666666h341.333334c93.866667 0 170.666667 76.8 170.666666 170.666666V554.666667c0 93.866667-76.8 170.666667-170.666666 170.666666z",
                });
              });
              return list;
            })(),
          },
          xAxis: [
            {
              type: "category",
              boundaryGap: true,
              data: obj.xAxis,
              axisPointer: {
                type: "shadow",
              },
              axisLabel: {
                interval: 0,
                margin: 10,
                textStyle: {
                  fontSize: 12,
                  fontFamily: "SimSun",
                  fontWeight: 400,
                  color: "#838DA1",
                },
              },
              axisTick: {
                // x轴刻度线
                show: false,
              },
              axisLine: {
                show: true,
                lineStyle: {
                  color: "#46494A",
                },
              },
            },
          ],
          yAxis: [
            {
              type: "value",
              min: 0,
              axisLabel: {
                margin: 15,
                textStyle: {
                  fontSize: 12,
                  fontFamily: "SimSun",
                  fontWeight: 400,
                  color: "#838DA1",
                },
                formatter: "{value}",
              },
              splitLine: {
                show: true,
                lineStyle: {
                  color: "#46494A",
                  type: [10, 10],
                  dashOffset: 5,
                },
              },
            },
          ],
          series: obj.series,
        };
      } else if (obj.searchType == "1") {
        option = {
          baseOption: {
            timeline: {
              show: false,
              top: 0,
              data: [],
            },
            grid: [
              {
                show: false,
                left: "4%",
                top: "5%",
                bottom: 49,
                containLabel: true,
                width: "37%",
              },
              {
                show: false,
                left: "51%",
                top: "5%",
                bottom: 69,
                width: "0%",
              },
              {
                show: false,
                right: "4%",
                top: "5%",
                bottom: 49,
                containLabel: true,
                width: "37.6%",
              },
            ],
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "cross",
                crossStyle: {
                  color: "#999",
                },
                label: {
                  padding: [5, 13, 5, 13],
                },
              },
              textStyle: {
                color: "#111E39",
                fontSize: 12,
                fontFamily: "Microsoft YaHei",
                fontWeight: 400,
              },
              formatter: (params) => {
                let dataStr = `<div><p style="font-weight:bold;margin:0 8px 10px;">${params[0].name}</p></div>`;
                params.forEach((item, i) => {
                  if (item.seriesName.indexOf("平均单价") > -1) {
                    dataStr += `<div style=${!item.data ? "display:none;" : "display:block"
                      }>
          <div style="margin: 0 8px;">
            <span style="display:inline-block;margin-right:4px;width:8px;height:8px;border-radius:2px;background:linear-gradient(0deg, ${item.color.colorStops[0].color
                      } 0%, ${item.color.colorStops[1].color} 100%);"></span>
            <span>${item.seriesName}</span>
            <span style="float:right;color:#000000;margin-left:20px;">${item.data
                      } 元/尾</span>
          </div>
        </div>`;
                  } else {
                    dataStr += `<div style=${!item.data ? "display:none;" : "display:block"
                      }>
          <div style="margin: 0 8px;">
            <span style="display:inline-block;margin-right:4px;width:8px;height:8px;border-radius:2px;background:linear-gradient(0deg, ${item.color.colorStops[0].color
                      } 0%, ${item.color.colorStops[1].color} 100%);"></span>
            <span>${item.seriesName}</span>
            <span style="float:right;color:#000000;margin-left:20px;">${item.data
                      } 尾</span>
          </div>
        </div>`;
                  }
                });
                return dataStr;
              },
            },
            legend: {
              type: "scroll",
              bottom: 10,
              left: 30,
              itemHeight: 8,
              itemGap: 40,
              itemWidth: 8,
              pageTextStyle: {
                color: "#9BA7BF",
                fontSize: 12,
                fontFamily: "SimSun",
              },
              pageIconColor: "#AAAAAA", //翻页下一页的三角按钮颜色
              pageIconInactiveColor: "#333333", //翻页按钮不激活时（即翻页到头时）的颜色。
              pageIconSize: 11, //翻页按钮大小
              data: (function () {
                let style = {
                  fontSize: 12,
                  fontFamily: "SimSun",
                  fontWeight: 400,
                  color: "#9BA7BF",
                };
                const list = [];
                obj.legend.forEach((re) => {
                  list.push({
                    name: re,
                    textStyle: style,
                    icon: "path://M682.666667 725.333333H341.333333c-93.866667 0-170.666667-76.8-170.666666-170.666666v-341.333334c0-93.866667 76.8-170.666667 170.666666-170.666666h341.333334c93.866667 0 170.666667 76.8 170.666666 170.666666V554.666667c0 93.866667-76.8 170.666667-170.666666 170.666666z",
                  });
                });
                return list;
              })(),
            },
            xAxis: [
              {
                type: "value",
                inverse: true,
                axisLine: {
                  show: false,
                },
                axisTick: {
                  show: false,
                },
                position: "bottom",
                axisLabel: {
                  show: true,
                  color: "#838DA1",
                  hideOverlap: true,
                },
                splitLine: {
                  show: true,
                  lineStyle: {
                    color: "#46494A",
                  },
                },
              },
              {
                gridIndex: 1,
                show: false,
              },
              {
                gridIndex: 2,
                axisLine: {
                  show: false,
                },
                axisTick: {
                  show: false,
                },
                position: "bottom",
                axisLabel: {
                  show: true,
                  color: "#838DA1",
                  hideOverlap: true,
                },
                splitLine: {
                  show: true,
                  lineStyle: {
                    color: "#46494A",
                  },
                },
              },
            ],
            yAxis: [
              {
                type: "category",
                inverse: true,
                position: "right",
                boundaryGap: true,
                axisPointer: {
                  type: "shadow",
                },
                axisLine: {
                  show: true,
                  lineStyle: {
                    color: "#46494A",
                  },
                },
                axisTick: {
                  show: false,
                },
                axisLabel: {
                  show: false,
                },
                data: obj.xAxis,
              },
              {
                gridIndex: 1,
                type: "category",
                inverse: true,
                position: "left",
                axisLine: {
                  show: false,
                },
                axisTick: {
                  show: false,
                },
                axisLabel: {
                  show: true,
                  padding: [30, 30, 30, 30],
                  textStyle: {
                    color: "#838DA1",
                    fontSize: 12,
                  },
                  align: "center",
                },
                data: obj.xAxis.map(function (value) {
                  return {
                    value: value,
                    textStyle: {
                      align: "center",
                    },
                  };
                }),
              },
              {
                gridIndex: 2,
                type: "category",
                inverse: true,
                position: "left",
                boundaryGap: true,
                axisPointer: {
                  type: "shadow",
                },
                axisLine: {
                  show: true,
                  lineStyle: {
                    color: "#46494A",
                  },
                },
                axisTick: {
                  show: false,
                },
                axisLabel: {
                  show: false,
                },
                data: obj.xAxis,
              },
            ],
            series: [],
          },
          options: [
            {
              series: obj.series,
            },
          ],
        };
      } else if (obj.searchType == "2") {
        option = {
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "cross",
              crossStyle: {
                color: "#999",
              },
            },
            textStyle: {
              color: "#111E39",
              fontSize: 12,
              fontFamily: "Microsoft YaHei",
              fontWeight: 400,
            },
            formatter: (params) => {
              let dataStr = `<div><p style="font-weight:bold;margin:0 8px 10px;">${params[0].name}</p></div>`;
              params.forEach((item, i) => {
                if (i == 0) {
                  dataStr += `<div style=${!item.data ? "display:none;" : "display:block"
                    }>
          <div style="margin: 0 8px;">
            <span style="display:inline-block;margin-right:4px;width:8px;height:8px;border-radius:2px;background:linear-gradient(0deg, ${item.color.colorStops[0].color
                    } 0%, ${item.color.colorStops[1].color} 100%);"></span>
            <span>${item.seriesName}</span>
            <span style="float:right;color:#000000;margin-left:20px;">${item.data
                    } 万元</span>
          </div>
        </div>`;
                } else {
                  dataStr += `<div style=${!item.data ? "display:none;" : "display:block"
                    }>
          <div style="margin: 0 6px;">
            <span style="display:inline-block;position:relative;width:8px;margin-right:5px;
            ">
            <svg class="icon" style="position:absolute;top:-9px" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" width="12" height="12"><path d="M682.667 307.2c17.066 0 34.133 17.067 34.133 34.133v341.334c0 17.066-17.067 34.133-34.133 34.133H341.333c-17.066 0-34.133-17.067-34.133-34.133V341.333c0-17.066 17.067-34.133 34.133-34.133h341.334m0-136.533H341.333c-93.866 0-170.666 76.8-170.666 170.666v341.334c0 93.866 76.8 170.666 170.666 170.666h341.334c93.866 0 170.666-76.8 170.666-170.666V341.333c0-93.866-76.8-170.666-170.666-170.666z" fill="#1afa29"/></svg>
            </span>
            <span>${item.seriesName}</span>
            <span style="float:right;color:#000000;margin-left:20px;">${item.data
                    } %</span>
          </div>
        </div>`;
                }
              });
              return dataStr;
            },
          },
          grid: {
            right: 30,
            top: showBol ? 60 : 25,
            bottom: 49,
            left: 30,
            width: "auto",
            containLabel: true,
          },
          legend: {
            type: "scroll",
            bottom: 10,
            left: 30,
            itemHeight: 8,
            itemGap: 40,
            itemWidth: 8,
            pageTextStyle: {
              color: "#9BA7BF",
              fontSize: 12,
              fontFamily: "SimSun",
            },
            pageIconColor: "#AAAAAA", //翻页下一页的三角按钮颜色
            pageIconInactiveColor: "#333333", //翻页按钮不激活时（即翻页到头时）的颜色。
            pageIconSize: 11, //翻页按钮大小
            data: (function () {
              let style = {
                fontSize: 12,
                fontFamily: "SimSun",
                fontWeight: 400,
                color: "#9BA7BF",
              };
              let list = [];
              obj.legend.forEach((re) => {
                if (re == "回收率") {
                  list.push({
                    name: re,
                    textStyle: style,
                    icon: "path://M682.666667 588.8c17.066667 0 34.133333-17.066667 34.133333-34.133333v-341.333334c0-17.066667-17.066667-34.133333-34.133333-34.133333H341.333333c-17.066667 0-34.133333 17.066667-34.133333 34.133333V554.666667c0 17.066667 17.066667 34.133333 34.133333 34.133333h341.333334M682.666667 725.333333H341.333333c-93.866667 0-170.666667-76.8-170.666666-170.666666v-341.333334c0-93.866667 76.8-170.666667 170.666666-170.666666h341.333334c93.866667 0 170.666667 76.8 170.666666 170.666666V554.666667c0 93.866667-76.8 170.666667-170.666666 170.666666z",
                  });
                } else {
                  list.push({
                    name: re,
                    textStyle: style,
                    icon: "path://M682.666667 725.333333H341.333333c-93.866667 0-170.666667-76.8-170.666666-170.666666v-341.333334c0-93.866667 76.8-170.666667 170.666666-170.666666h341.333334c93.866667 0 170.666667 76.8 170.666666 170.666666V554.666667c0 93.866667-76.8 170.666667-170.666666 170.666666z",
                  });
                }
              });
              return list;
            })(),
          },
          xAxis: [
            {
              type: "category",
              data: obj.xAxis,
              boundaryGap: true,
              axisPointer: {
                type: "shadow",
              },
              axisLabel: {
                interval: 0,
                margin: 10,
                textStyle: {
                  fontSize: 12,
                  fontFamily: "SimSun",
                  fontWeight: 400,
                  color: "#838DA1",
                },
              },
              axisTick: {
                // x轴刻度线
                show: false,
              },
              axisLine: {
                show: true,
                lineStyle: {
                  color: "#46494A",
                },
              },
            },
          ],
          yAxis: [
            {
              type: "value",
              min: 0,
              axisLabel: {
                margin: 15,
                textStyle: {
                  fontSize: 12,
                  fontFamily: "SimSun",
                  fontWeight: 400,
                  color: "#838DA1",
                },
                formatter: "{value}",
              },
              splitLine: {
                show: true,
                lineStyle: {
                  color: "#46494A",
                  type: [10, 10],
                  dashOffset: 5,
                },
              },
            },
            {
              type: "value",
              min: 0,
              interval: 10,
              axisLabel: {
                margin: 10,
                textStyle: {
                  fontSize: 12,
                  fontFamily: "SimSun",
                  fontWeight: 400,
                  color: "#838DA1",
                },
                formatter: "",
              },
              splitLine: {
                show: false,
              },
            },
          ],
          series: obj.series,
        };
      }
      if (showBol) {
        this.isShowChart = true;
        this.closeFormatter(option)
        setTimeout(() => {
          // this.showChart.chartDom && this.showChart.chartDom.clear();
          this.showChart.chartDom = new $echarts.init(
            document.getElementById(this.showChart.idName)
          );
          this.showChart.chartDom.clear()
          if (obj.searchType == 0) {
            // 柱状图显示label在顶端
            option.series.forEach((item) => {
              // item.barMaxWidth='10'
              item.barMinWidth = "10";
              item.barGap = 1;
              item.label = {
                normal: {
                  show: true,
                  position: "center",
                  textStyle: {
                    color: "white",
                    fontStyle: "normal",
                    fontFamily: "微软雅黑",
                    fontSize: 12,
                  },
                  // offset: [0, 0],
                  distance: "10",
                  rotate: "90",
                  formatter: (param) => {
                    if (param.value == 0) {
                      return ``;
                    }
                    return param.value;
                  },
                },
              };
            });
          } else if (obj.searchType == 1) {
            option.options[0].series.forEach((item) => {
              item.barMinWidth = "10";
              item.barGap = 1;
              item.label = {
                normal: {
                  show: true,
                  textStyle: {
                    color: "white",
                    fontStyle: "normal",
                    fontFamily: "微软雅黑",
                    fontSize: 12,
                  },
                  position: item.yAxisIndex ? "right" : "left",
                  // offset: [0, 0],
                  // distance: "-300",
                  // rotate: "90",
                  formatter: (param) => {
                    if (param.value == 0) {
                      return ``;
                    }
                    return param.value;
                  },
                },
              };
            });
          } else if (obj.searchType == 2) {
            obj.series.forEach((item) => {
              if (item.type === "bar") {
                item.barMinWidth = "16";
                item.label = {
                  normal: {
                    show: true,
                    fontSize: 12,
                    color: "#ffffff",
                    position: "top",
                    formatter: (params) => {
                      if (params.value == 0) {
                        return ``;
                      }
                      return params.value; //随便写的值
                    },
                  },
                };
              } else if (item.type === "line") {
                item.symbolSize = 20;
                item.label = {
                  show: true,
                  fontSize: 12,
                  color: item.color,
                  position: "top",
                  distance: "30",
                  formatter: (params) => {
                    return params.value + "%"; //随便写的值
                  },
                };
              }
            });
          }
          this.showChart.chartDom.setOption(option, this.animationDuration);
        });
        return;
      }
      this.sales.chartDom && this.sales.chartDom.clear();
      this.sales.chartDom = new $echarts.init(
        document.getElementById(obj.idName)
      );
      if (option && typeof option === "object") {
        this.sales.chartDom.setOption(option, this.animationDuration);
      }
    },
    prefixChart(obj, showBol) {
      // 配置图标属性
      let option = {
        tooltip: {
          trigger: "axis",
          // enterable: true, // 鼠标可在tooltip上面移动
          // className: "tooltip-scroll", // 类名
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#999",
            },
          },
          textStyle: {
            color: "#111E39",
            fontSize: 12,
            fontFamily: "Microsoft YaHei",
            fontWeight: 400,
          },
          formatter: (params) => {
            let dataStr = `<div><p style="font-weight:bold;margin:0 8px 10px;">${params[0].name}</p></div>`;
            params.forEach((item, i) => {
              dataStr += `<div style=${!item.data ? "display:none;" : "display:block"
                }>
          <div style="margin: 0 8px;">
            <span style="display:inline-block;margin-right:4px;width:8px;height:8px;border-radius:2px;background:linear-gradient(0deg, ${item.color.colorStops[0].color
                } 0%, ${item.color.colorStops[1].color} 100%);"></span>
            <span>${item.seriesName}</span>
            <span style="float:right;color:#000000;margin-left:20px;">${item.data
                } 元/尾</span>
          </div>
        </div>`;
            });
            return dataStr;
          },
        },
        grid: {
          right: 30,
          top: 25,
          bottom: 49,
          left: 30,
          width: "auto",
          containLabel: true,
        },
        legend: {
          type: "scroll",
          bottom: 10,
          left: 30,
          itemHeight: 8,
          itemGap: 40,
          itemWidth: 8,
          pageTextStyle: {
            color: "#9BA7BF",
            fontSize: 12,
            fontFamily: "SimSun",
          },
          pageIconColor: "#AAAAAA", //翻页下一页的三角按钮颜色
          pageIconInactiveColor: "#333333", //翻页按钮不激活时（即翻页到头时）的颜色。
          pageIconSize: 11, //翻页按钮大小
          data: (function () {
            let style = {
              fontSize: 12,
              fontFamily: "SimSun",
              fontWeight: 400,
              color: "#9BA7BF",
            };
            const list = [];
            obj.legend.forEach((re) => {
              list.push({
                name: re,
                textStyle: style,
                icon: "path://M682.666667 725.333333H341.333333c-93.866667 0-170.666667-76.8-170.666666-170.666666v-341.333334c0-93.866667 76.8-170.666667 170.666666-170.666666h341.333334c93.866667 0 170.666667 76.8 170.666666 170.666666V554.666667c0 93.866667-76.8 170.666667-170.666666 170.666666z",
              });
            });
            return list;
          })(),
        },
        xAxis: [
          {
            type: "category",
            data: obj.xAxis,
            boundaryGap: true,
            axisPointer: {
              type: "shadow",
            },
            axisLabel: {
              interval: 0,
              margin: 10,
              textStyle: {
                fontSize: 12,
                fontFamily: "SimSun",
                fontWeight: 400,
                color: "#838DA1",
              },
            },
            axisTick: {
              // x轴刻度线
              show: false,
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#46494A",
              },
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            min: 0,
            axisLabel: {
              margin: 15,
              textStyle: {
                fontSize: 12,
                fontFamily: "SimSun",
                fontWeight: 400,
                color: "#838DA1",
              },
              formatter: "{value}",
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "#46494A",
                type: [10, 10],
                dashOffset: 5,
              },
            },
          },
        ],
        series: obj.series,
      };
      if (showBol) {
        this.isShowChart = true;
        this.closeFormatter(option)
        setTimeout(() => {
          obj.chartDom && obj.chartDom.clear();
          obj.chartDom = new $echarts.init(document.getElementById(obj.idName));
          if (option && typeof option === "object") {
            // 柱状图显示label在顶端
            option.series.forEach((item) => {
              // item.barMaxWidth='10'
              item.barMinWidth = "8";
              item.barGap = 0;
              item.label = {
                normal: {
                  show: true,
                  position: "center",
                  textStyle: {
                    color: "white",
                    fontStyle: "normal",
                    fontFamily: "微软雅黑",
                    fontSize: 10,
                  },
                  // offset: [0, 0],
                  distance: "10",
                  rotate: "90",
                  formatter: (param) => {
                    if (param.value == 0) {
                      return ``;
                    }
                    return param.value;
                  },
                },
              };
            });
            obj.chartDom.setOption(option, this.animationDuration);
          }
        });
        return;
      }
      this.prefix.chartDom && this.prefix.chartDom.clear();
      this.prefix.chartDom = new $echarts.init(
        document.getElementById(obj.idName)
      );
      if (option && typeof option === "object") {
        this.prefix.chartDom.setOption(option, this.animationDuration);
      }
    },
    costChart(obj, showBol) {
      let option = {
        tooltip: {
          trigger: "axis",
          confine: true, // 固定弹出框置于父组件下方，不超出父组件顶部
          appendToBody: true, // 解决弹出框可以浮动到其他同级盒子上方的问题
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#999",
            },
          },
          textStyle: {
            color: "#111E39",
            fontSize: 12,
            fontFamily: "Microsoft YaHei",
            fontWeight: 400,
          },
          formatter: (params) => {
            let dataStr = `<div><p style="font-weight:bold;margin:0 8px 10px;">${params[0].name}</p></div>`;
            params.forEach((item, i) => {
              dataStr += `<div style=${!item.data ? "display:none;" : "display:block"
                }>
          <div style="margin: 0 8px;">
            <span style="display:inline-block;margin-right:4px;width:8px;height:8px;border-radius:2px;background:linear-gradient(0deg, ${item.color.colorStops[0].color
                } 0%, ${item.color.colorStops[1].color} 100%);"></span>
            <span>${item.seriesName}</span>
            <span style="float:right;color:#000000;margin-left:20px;">${item.data
                } 万元</span>
          </div>
        </div>`;
            });
            return dataStr;
          },
        },
        grid: {
          right: 30,
          top: showBol ? 30 : 5,
          bottom: 49,
          left: 30,
          width: "auto",
          containLabel: true,
        },
        legend: {
          type: "scroll",
          bottom: 10,
          left: 30,
          itemHeight: 8,
          itemGap: 40,
          itemWidth: 8,
          pageTextStyle: {
            color: "#9BA7BF",
            fontSize: 12,
            fontFamily: "SimSun",
          },
          pageIconColor: "#AAAAAA", //翻页下一页的三角按钮颜色
          pageIconInactiveColor: "#333333", //翻页按钮不激活时（即翻页到头时）的颜色。
          pageIconSize: 11, //翻页按钮大小
          data: (function () {
            let style = {
              fontSize: 12,
              fontFamily: "SimSun",
              fontWeight: 400,
              color: "#9BA7BF",
            };
            const list = [];
            obj.legend.forEach((re) => {
              list.push({
                name: re,
                textStyle: style,
                icon: "path://M682.666667 725.333333H341.333333c-93.866667 0-170.666667-76.8-170.666666-170.666666v-341.333334c0-93.866667 76.8-170.666667 170.666666-170.666666h341.333334c93.866667 0 170.666667 76.8 170.666666 170.666666V554.666667c0 93.866667-76.8 170.666667-170.666666 170.666666z",
              });
            });
            return list;
          })(),
        },
        xAxis: [
          {
            type: "category",
            data: obj.xAxis,
            boundaryGap: true,
            axisPointer: {
              type: "shadow",
            },
            axisLabel: {
              interval: 0,
              margin: 10,
              textStyle: {
                fontSize: 12,
                fontFamily: "SimSun",
                fontWeight: 400,
                color: "#838DA1",
              },
            },
            axisTick: {
              // x轴刻度线
              show: false,
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#46494A",
              },
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            min: 0,
            axisLabel: {
              margin: 15,
              textStyle: {
                fontSize: 12,
                fontFamily: "SimSun",
                fontWeight: 400,
                color: "#838DA1",
              },
              formatter: "{value}",
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "#46494A",
                type: [10, 10],
                dashOffset: 5,
              },
            },
          },
        ],
        series: obj.series,
      };
      if (showBol) {
        this.isShowChart = true;
        this.closeFormatter(option)
        setTimeout(() => {
          obj.chartDom && obj.chartDom.clear();
          obj.chartDom = new $echarts.init(document.getElementById(obj.idName));
          if (option && typeof option === "object") {
            // 柱状图显示label在顶端
            option.series.forEach((item) => {
              // item.barMaxWidth='10'
              item.barMinWidth = "10";
              item.barGap = 1;
              item.label = {
                normal: {
                  show: true,
                  position: "center",
                  textStyle: {
                    color: "white",
                    fontStyle: "normal",
                    fontFamily: "微软雅黑",
                    fontSize: 12,
                  },
                  // offset: [0, 0],
                  distance: "10",
                  rotate: "90",
                  formatter: (param) => {
                    if (param.value == 0) {
                      return ``;
                    }
                    return param.value;
                  },
                },
              };
            });
            obj.chartDom.setOption(option, this.animationDuration);
          }
        });
        return;
      }
      this.cost.chartDom && this.cost.chartDom.clear();
      this.cost.chartDom = new $echarts.init(
        document.getElementById(obj.idName)
      );
      if (option && typeof option === "object") {
        this.cost.chartDom.setOption(option, this.animationDuration);
      }
    },
    harvestChart(obj, showBol) {
      let option = {};
      if (obj.searchType == "0") {
        option = {
          baseOption: {
            timeline: {
              show: false,
              top: 0,
              data: [],
            },
            grid: [
              {
                show: false,
                left: "4%",
                top: "5%",
                bottom: 49,
                containLabel: true,
                width: "37%",
              },
              {
                show: false,
                left: "51%",
                top: "5%",
                bottom: 69,
                width: "0%",
              },
              {
                show: false,
                right: "4%",
                top: "5%",
                bottom: 49,
                containLabel: true,
                width: "37.6%",
              },
            ],
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "cross",
                crossStyle: {
                  color: "#999",
                },
                label: {
                  padding: [5, 13, 5, 13],
                },
              },
              textStyle: {
                color: "#111E39",
                fontSize: 12,
                fontFamily: "Microsoft YaHei",
                fontWeight: 400,
              },
              formatter: (params) => {
                let dataStr = `<div><p style="font-weight:bold;margin:0 8px 10px;">${params[0].name}</p></div>`;
                params.forEach((item, i) => {
                  if (item.seriesName.indexOf("每公斤出苗量") > -1) {
                    dataStr += `<div style=${!item.data ? "display:none;" : "display:block"
                      }>
          <div style="margin: 0 8px;">
            <span style="display:inline-block;margin-right:4px;width:8px;height:8px;border-radius:2px;background:linear-gradient(0deg, ${item.color.colorStops[0].color
                      } 0%, ${item.color.colorStops[1].color} 100%);"></span>
            <span>${item.seriesName}</span>
            <span style="float:right;color:#000000;margin-left:20px;">${item.data
                      } 万尾/公斤</span>
          </div>
        </div>`;
                  } else {
                    dataStr += `<div style=${!item.data ? "display:none;" : "display:block"
                      }>
          <div style="margin: 0 8px;">
            <span style="display:inline-block;margin-right:4px;width:8px;height:8px;border-radius:2px;background:linear-gradient(0deg, ${item.color.colorStops[0].color
                      } 0%, ${item.color.colorStops[1].color} 100%);"></span>
            <span>${item.seriesName}</span>
            <span style="float:right;color:#000000;margin-left:20px;">${item.data
                      } 万尾</span>
          </div>
        </div>`;
                  }
                });
                return dataStr;
              },
            },
            legend: {
              type: "scroll",
              bottom: 10,
              left: 30,
              itemHeight: 8,
              itemGap: 40,
              itemWidth: 8,
              pageTextStyle: {
                color: "#9BA7BF",
                fontSize: 12,
                fontFamily: "SimSun",
              },
              pageIconColor: "#AAAAAA", //翻页下一页的三角按钮颜色
              pageIconInactiveColor: "#333333", //翻页按钮不激活时（即翻页到头时）的颜色。
              pageIconSize: 11, //翻页按钮大小
              data: (function () {
                let style = {
                  fontSize: 12,
                  fontFamily: "SimSun",
                  fontWeight: 400,
                  color: "#9BA7BF",
                };
                const list = [];
                obj.legend.forEach((re) => {
                  list.push({
                    name: re,
                    textStyle: style,
                    icon: "path://M682.666667 725.333333H341.333333c-93.866667 0-170.666667-76.8-170.666666-170.666666v-341.333334c0-93.866667 76.8-170.666667 170.666666-170.666666h341.333334c93.866667 0 170.666667 76.8 170.666666 170.666666V554.666667c0 93.866667-76.8 170.666667-170.666666 170.666666z",
                  });
                });
                return list;
              })(),
            },
            xAxis: [
              {
                type: "value",
                inverse: true,
                axisLine: {
                  show: false,
                },
                axisTick: {
                  show: false,
                },
                position: "bottom",
                axisLabel: {
                  show: true,
                  color: "#838DA1",
                  hideOverlap: true,
                },
                splitLine: {
                  show: true,
                  lineStyle: {
                    color: "#46494A",
                  },
                },
              },
              {
                gridIndex: 1,
                show: false,
              },
              {
                gridIndex: 2,
                axisLine: {
                  show: false,
                },
                axisTick: {
                  show: false,
                },
                position: "bottom",
                axisLabel: {
                  show: true,
                  color: "#838DA1",
                  hideOverlap: true,
                },
                splitLine: {
                  show: true,
                  lineStyle: {
                    color: "#46494A",
                  },
                },
              },
            ],
            yAxis: [
              {
                type: "category",
                inverse: true,
                position: "right",
                boundaryGap: true,
                axisPointer: {
                  type: "shadow",
                },
                axisLine: {
                  show: true,
                  lineStyle: {
                    color: "#46494A",
                  },
                },
                axisTick: {
                  show: false,
                },
                axisLabel: {
                  show: false,
                },
                data: obj.xAxis,
              },
              {
                gridIndex: 1,
                type: "category",
                inverse: true,
                position: "left",
                axisLine: {
                  show: false,
                },
                axisTick: {
                  show: false,
                },
                axisLabel: {
                  show: true,
                  padding: [30, 30, 30, 30],
                  textStyle: {
                    color: "#838DA1",
                    fontSize: 12,
                  },
                  align: "center",
                },
                data: obj.xAxis.map(function (value) {
                  return {
                    value: value,
                    textStyle: {
                      align: "center",
                    },
                  };
                }),
              },
              {
                gridIndex: 2,
                type: "category",
                inverse: true,
                position: "left",
                boundaryGap: true,
                axisPointer: {
                  type: "shadow",
                },
                axisLine: {
                  show: true,
                  lineStyle: {
                    color: "#46494A",
                  },
                },
                axisTick: {
                  show: false,
                },
                axisLabel: {
                  show: false,
                },
                data: obj.xAxis,
              },
            ],
            series: [],
          },
          options: [
            {
              series: obj.series,
            },
          ],
        };
      } else {
        option = {
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "cross",
              crossStyle: {
                color: "#999",
              },
            },
            textStyle: {
              color: "#111E39",
              fontSize: 12,
              fontFamily: "Microsoft YaHei",
              fontWeight: 400,
            },
            formatter: (params) => {
              let dataStr = `<div><p style="font-weight:bold;margin:0 8px 10px;">${params[0].name}</p></div>`;
              params.forEach((item, i) => {
                dataStr += `<div style=${!item.data ? "display:none;" : "display:block"
                  }>
          <div style="margin: 0 8px;">
            <span style="display:inline-block;margin-right:4px;width:8px;height:8px;border-radius:2px;background:linear-gradient(0deg, ${item.color.colorStops[0].color
                  } 0%, ${item.color.colorStops[1].color} 100%);"></span>
            <span>${item.seriesName}</span>
            <span style="float:right;color:#000000;margin-left:20px;">${item.data
                  } 口</span>
          </div>
        </div>`;
              });
              return dataStr;
            },
          },
          grid: {
            right: 30,
            top: 30,
            bottom: 49,
            left: 30,
            width: "auto",
            containLabel: true,
          },
          legend: {
            type: "scroll",
            bottom: 10,
            left: 30,
            itemHeight: 8,
            itemGap: 40,
            itemWidth: 8,
            pageTextStyle: {
              color: "#9BA7BF",
              fontSize: 12,
              fontFamily: "SimSun",
            },
            pageIconColor: "#AAAAAA", //翻页下一页的三角按钮颜色
            pageIconInactiveColor: "#333333", //翻页按钮不激活时（即翻页到头时）的颜色。
            pageIconSize: 11, //翻页按钮大小
            data: (function () {
              let style = {
                fontSize: 12,
                fontFamily: "SimSun",
                fontWeight: 400,
                color: "#9BA7BF",
              };
              const list = [];
              obj.legend.forEach((re) => {
                list.push({
                  name: re,
                  textStyle: style,
                  icon: "path://M682.666667 725.333333H341.333333c-93.866667 0-170.666667-76.8-170.666666-170.666666v-341.333334c0-93.866667 76.8-170.666667 170.666666-170.666666h341.333334c93.866667 0 170.666667 76.8 170.666666 170.666666V554.666667c0 93.866667-76.8 170.666667-170.666666 170.666666z",
                });
              });
              return list;
            })(),
          },
          xAxis: [
            {
              type: "category",
              data: obj.xAxis,
              boundaryGap: true,
              axisPointer: {
                type: "shadow",
              },
              axisLabel: {
                interval: 0,
                margin: 10,
                textStyle: {
                  fontSize: 12,
                  fontFamily: "SimSun",
                  fontWeight: 400,
                  color: "#838DA1",
                },
              },
              axisTick: {
                // x轴刻度线
                show: false,
              },
              axisLine: {
                show: true,
                lineStyle: {
                  color: "#46494A",
                },
              },
            },
          ],
          yAxis: [
            {
              type: "value",
              min: 0,
              axisLabel: {
                margin: 15,
                textStyle: {
                  fontSize: 12,
                  fontFamily: "SimSun",
                  fontWeight: 400,
                  color: "#838DA1",
                },
                formatter: "{value}",
              },
              splitLine: {
                show: true,
                lineStyle: {
                  color: "#46494A",
                  type: [10, 10],
                  dashOffset: 5,
                },
              },
            },
          ],
          series: obj.series,
        };
      }
      if (showBol) {
        this.isShowChart = true;
        this.closeFormatter(option)
        setTimeout(() => {
          this.showChart.chartDom && this.showChart.chartDom.clear();
          this.showChart.chartDom = new $echarts.init(
            document.getElementById(this.showChart.idName)
          );
          this.showChart.chartDom.clear();
          if (obj.searchType == 0) {
            option.options[0].series.forEach((item) => {
              item.barMinWidth = "10";
              item.barGap = 1;
              item.label = {
                normal: {
                  show: true,
                  textStyle: {
                    color: "white",
                    fontStyle: "normal",
                    fontFamily: "微软雅黑",
                    fontSize: 12,
                  },
                  position: item.yAxisIndex ? "right" : "left",
                  // offset: [0, 0],
                  // distance: "-300",
                  // rotate: "90",
                  formatter: (param) => {
                    if (param.value == 0) {
                      return ``;
                    }
                    return param.value;
                  },
                },
              };
            });
          } else {
            option.series.forEach((item) => {
              item.barMinWidth = "10";
              item.barGap = 1;
              item.label = {
                normal: {
                  show: true,
                  position: "center",
                  textStyle: {
                    color: "white",
                    fontStyle: "normal",
                    fontFamily: "微软雅黑",
                    fontSize: 12,
                  },
                  // offset: [0, 0],
                  distance: "10",
                  rotate: "90",
                  formatter: (param) => {
                    if (param.value == 0) {
                      return ``;
                    }
                    return param.value;
                  },
                },
              };
            });
          }
          this.showChart.chartDom.setOption(option, this.animationDuration);
        });
        return;
      }
      this.harvest.chartDom && this.harvest.chartDom.clear();
      this.harvest.chartDom = new $echarts.init(
        document.getElementById(obj.idName)
      );
      if (option && typeof option === "object") {
        this.harvest.chartDom.setOption(option, this.animationDuration);
      }
    },
    quotaChart(obj, showBol) {
      let option = {
        tooltip: {
          trigger: "axis",
          // enterable: true, // 鼠标可在tooltip上面移动
          // className: "tooltip-scroll", // 类名
          textStyle: {
            color: "#111E39",
            fontSize: 12,
            fontFamily: "Microsoft YaHei",
            fontWeight: 400,
          },
          extraCssText: "z-index:999",
          formatter: (params) => {
            let dataStr = `<div><p style="font-weight:bold;margin:0 8px 10px;">${params[0].name}</p></div>`;
            params.forEach((item) => {
              dataStr += `<div style=${!item.data ? "display:none;" : "display:block"
                }>
          <div style="margin: 0 8px;">
            <span style="display:inline-block;margin-right:4px;width:8px;height:8px;border-radius:2px;background:${item.color
                };"></span>
            <span>${item.seriesName}</span>
            <span style="float:right;color:#000000;margin-left:20px;">${item.data
                } ${obj.searchType == "0" ? "%" : ""}</span>
          </div>
        </div>`;
            });
            return dataStr;
          },
        },
        grid: {
          right: 30,
          top: showBol ? 60 : 30,
          bottom: 49,
          left: 30,
          width: "auto",
          containLabel: true,
        },
        legend: {
          type: "scroll",
          bottom: 10,
          left: 30,
          itemHeight: 8,
          itemGap: 40,
          itemWidth: 8,
          pageTextStyle: {
            color: "#9BA7BF",
            fontSize: 12,
            fontFamily: "SimSun",
          },
          pageIconColor: "#AAAAAA", //翻页下一页的三角按钮颜色
          pageIconInactiveColor: "#333333", //翻页按钮不激活时（即翻页到头时）的颜色。
          pageIconSize: 11, //翻页按钮大小
          data: (function () {
            const style = {
              fontSize: 12,
              fontFamily: "SimSun",
              fontWeight: 400,
              color: "#9BA7BF",
            };
            var list = [];
            obj.legend.forEach((re) => {
              list.push({
                name: re,
                textStyle: style,
                icon: "path://M682.666667 725.333333H341.333333c-93.866667 0-170.666667-76.8-170.666666-170.666666v-341.333334c0-93.866667 76.8-170.666667 170.666666-170.666666h341.333334c93.866667 0 170.666667 76.8 170.666666 170.666666V554.666667c0 93.866667-76.8 170.666667-170.666666 170.666666z",
              });
            });
            return list;
          })(),
        },
        xAxis: [
          {
            type: "category",
            data: obj.xAxis,
            boundaryGap: true,
            axisPointer: {
              type: "shadow",
            },
            axisLabel: {
              interval: 0,
              margin: 10,
              textStyle: {
                fontSize: 12,
                fontFamily: "SimSun",
                fontWeight: 400,
                color: "#838DA1",
              },
            },
            axisTick: {
              // x轴刻度线
              show: false,
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#46494A",
              },
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            min: 0,
            axisLabel: {
              margin: 15,
              textStyle: {
                fontSize: 12,
                fontFamily: "SimSun",
                fontWeight: 400,
                color: "#838DA1",
              },
              formatter: "{value}",
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "#46494A",
                type: [10, 10],
                dashOffset: 5,
              },
            },
          },
        ],
        series: obj.series,
      };
      if (showBol) {
        this.isShowChart = true;
        this.closeFormatter(option)
        setTimeout(() => {
          this.showChart.chartDom && this.showChart.chartDom.clear();
          this.showChart.chartDom = new $echarts.init(
            document.getElementById(this.showChart.idName)
          );
          // 柱状图显示label在顶端
          option.series.forEach((item) => {
            // item.barMaxWidth='10'
            item.barMinWidth = "10";
            item.barGap = 1;
            item.label = {
              normal: {
                show: true,
                position: "center",
                textStyle: {
                  color: "white",
                  fontStyle: "normal",
                  fontFamily: "微软雅黑",
                  fontSize: 12,
                },
                // offset: [0, 0],
                distance: "10",
                rotate: "90",
                formatter: (param) => {
                  if (param.value == 0) {
                    return ``;
                  }
                  return param.value;
                },
              },
            };
          });
          this.showChart.chartDom.setOption(option, this.animationDuration);
        });
        return;
      }
      this.quota.chartDom && this.quota.chartDom.clear();
      this.quota.chartDom = new $echarts.init(
        document.getElementById(obj.idName)
      );
      if (option && typeof option === "object") {
        this.quota.chartDom.setOption(option, this.animationDuration);
      }
    },
    //
    //////////////////////////////////////// 请求 ///////////////////////////////////////////////
    //
    // 年度经营目标完成情况
    annalsTargetInfo: function (searchType /**指标类型 0 ~ n */, showBol) {
      annalsTargetInfo({
        orgId: this.orgId,
        type: this.type,
        year: this.year,
        month: this.month,
        breedTypeClass: this.breedTypeClass,
        searchType: searchType,
      }).then((data) => {
        if (data.code == "0000") {
          const DATA = data.data || [];
          // const DATA = require(`../../../test/president/annals/${searchType}.json`);
          this.annalsTarget.legend = [];
          this.annalsTarget.xAxis = [];
          this.annalsTarget.series = [];
          const colors = [
            ["#5442FF", "#907BFE"],
            ["#8540FF", "#B681FF"],
            "#51FF98",
          ];

          // 赋值， 过滤数据
          this.annalsTarget.xAxis =
            (DATA.length > 0 &&
              DATA[0].dataList.map((re) => {
                return re.xAxisName;
              })) ||
            [];
          this.annalsTarget.legend =
            (DATA.length > 0 &&
              DATA.map((re) => {
                return re.legendName;
              })) ||
            [];
          DATA.length > 0 &&
            DATA.forEach((re, i) => {
              if (re.legendName == "完成率") {
                this.annalsTarget.series.push({
                  name: re.legendName,
                  data:
                    (re.dataList &&
                      re.dataList.map((sub) => {
                        return sub.yAxisValue;
                      })) ||
                    [],
                  type: "line",
                  color: colors[i],
                  smooth: true,
                  symbol: "none",
                  yAxisIndex: 1,
                  lineStyle: {
                    width: 1.2,
                  },
                });
              } else {
                this.annalsTarget.series.push({
                  name: re.legendName,
                  data:
                    (re.dataList &&
                      re.dataList.map((sub) => {
                        return sub.yAxisValue;
                      })) ||
                    [],
                  type: "bar",
                  barMaxWidth: "5",
                  barGap: 3,
                  itemStyle: {
                    color: new $echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      { offset: 1, color: colors[i][0] },
                      { offset: 0, color: colors[i][1] },
                    ]),
                    barBorderRadius: 50,
                  },
                  emphasis: {
                    itemStyle: {
                      color: new $echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        { offset: 1, color: colors[i][0] },
                        { offset: 0, color: colors[i][1] },
                      ]),
                    },
                  },
                });
              }
            });
          this.annalsTarget.unit = {
            1: "公斤",
            2: "万尾",
            3: "万元",
            4: "万元",
          }[+searchType];
          if (showBol) {
            this.showChart.unit = this.annalsTarget.unit;
            this.showChart.legend = this.annalsTarget.legend;
            this.showChart.series = this.annalsTarget.series;
            this.showChart.xAxis = this.annalsTarget.xAxis;
            this.annalsTargetChart(this.showChart, true);
            return;
          }
          this.annalsTargetChart(this.annalsTarget);
        }
      });
    },
    // 投放概览
    putInfo: function (searchType /**指标类型 0 ~ n */, showBol) {
      putInfo({
        orgId: this.orgId,
        type: this.type,
        year: this.year,
        month: this.month,
        breedTypeClass: this.breedTypeClass,
        searchType: searchType,
      }).then((data) => {
        if (data.code == "0000") {
          const DATA = data.data || [];
          // const DATA = require(`../../../test/president/put/${searchType}.json`);
          this.put.legend = [];
          this.put.xAxis = [];
          this.put.series = [];
          // UI默认色值
          const colors = [
            ["#5442FF", "#907BFE"],
            ["#8540FF", "#B681FF"],
            ["#68A380", "#80B69F"],
          ];
          // 赋值， 过滤数据
          this.put.xAxis =
            (DATA.length > 0 &&
              DATA[0].dataList.map((re) => {
                return re.xAxisName;
              })) ||
            [];
          this.put.legend =
            (DATA.length > 0 &&
              DATA.map((re) => {
                return re.legendName;
              })) ||
            [];
          /////////////////////////////////////////////
          ///////////     投卵情况         /////////////
          /////////////////////////////////////////////
          if (searchType == "1") {
            DATA.length > 0 &&
              DATA.forEach((re, i) => {
                if (i > 2) {
                  // 随机颜色
                  let random = this.$color.getItemColors(
                    this.$color.randex(),
                    3
                  );
                  colors.push([random[0], random[random.length - 1]]);
                }
                this.put.series.push({
                  name: re.legendName,
                  data:
                    (re.dataList &&
                      re.dataList.map((sub) => {
                        return sub.yAxisValue;
                      })) ||
                    [],
                  type: "bar",
                  barMaxWidth: "5",
                  barGap: 3,
                  itemStyle: {
                    color: new $echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      { offset: 1, color: colors[i][0] },
                      { offset: 0, color: colors[i][1] },
                    ]),
                    barBorderRadius: 50,
                  },
                  emphasis: {
                    itemStyle: {
                      color: new $echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        { offset: 1, color: colors[i][0] },
                        { offset: 0, color: colors[i][1] },
                      ]),
                    },
                  },
                });
              });
          } else {
            /////////////////////////////////////////////
            ///////////     排塘情况         /////////////
            /////////////////////////////////////////////
            for (let i = 0; i < DATA.length; i++) {
              const re = DATA[i];
              if (i > 2 && i < DATA.length - 1) {
                // 随机颜色
                let random = this.$color.getItemColors(this.$color.randex(), 3);
                colors.push([random[0], random[random.length - 1]]);
              }
              if (re.legendName == "排塘率") {
                this.put.series.push({
                  name: re.legendName,
                  data:
                    (re.dataList &&
                      re.dataList.map((sub) => {
                        return sub.yAxisValue;
                      })) ||
                    [],
                  type: "line",
                  color: "#6473F5",
                  symbol: "none",
                  smooth: true,
                  yAxisIndex: 1,
                  lineStyle: {
                    width: 1.2,
                  },
                });
              } else {
                if (!colors[i]) {
                  break;
                }
                this.put.series.push({
                  name: re.legendName,
                  data:
                    (re.dataList &&
                      re.dataList.map((sub) => {
                        return sub.yAxisValue;
                      })) ||
                    [],
                  type: "bar",
                  barMaxWidth: "5",
                  barGap: 3,
                  itemStyle: {
                    color: new $echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      { offset: 1, color: colors[i][0] },
                      { offset: 0, color: colors[i][1] },
                    ]),
                    barBorderRadius: 50,
                  },
                  emphasis: {
                    itemStyle: {
                      color: new $echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        { offset: 1, color: colors[i][0] },
                        { offset: 0, color: colors[i][1] },
                      ]),
                    },
                  },
                });
              }
            }
          }
          this.put.unit = {
            1: "公斤",
            2: "万元",
          }[+searchType];
          if (showBol) {
            this.showChart.unit = this.put.unit;
            this.showChart.legend = this.put.legend;
            this.showChart.series = this.put.series;
            this.showChart.xAxis = this.put.xAxis;
            this.putChart(this.showChart, true);
            return;
          }
          this.putChart(this.put);
        }
      });
    },
    // 存塘概览
    storageInfo: function (searchType /**指标类型 0 ~ n */, showBol) {
      storageInfo({
        orgId: this.orgId,
        type: this.type,
        year: this.year,
        month: this.month,
        breedTypeClass: this.breedTypeClass,
        searchType: searchType,
      }).then((data) => {
        if (data.code == "0000") {
          const DATA = data.data || [];
          // const DATA = require(`../../../test/president/storage/${searchType}.json`);
          this.storage.legend = [];
          this.storage.xAxis = [];
          this.storage.series = [];
          // UI默认色值
          const colors = [
            ["#5442FF", "#907BFE"],
            ["#8540FF", "#B681FF"],
            ["#68A380", "#80B69F"],
          ];
          // 赋值， 过滤数据
          this.storage.xAxis =
            (DATA.length > 0 &&
              DATA[0].dataList.map((re) => {
                return re.xAxisName;
              })) ||
            [];
          this.storage.legend =
            (DATA.length > 0 &&
              DATA.map((re) => {
                return re.legendName;
              })) ||
            [];
          /////////////////////////////////////////////
          ///////////     实时存塘量       /////////////
          /////////////////////////////////////////////
          if (searchType == "1") {
            for (let i = 0; i < DATA.length; i++) {
              const re = DATA[i];
              if (i > 2) {
                // 随机颜色
                let random = this.$color.getItemColors(this.$color.randex(), 4);
                colors.push([random[0], random[random.length - 1]]);
              }
              if (!colors[i]) {
                break;
              }
              if (re.legendName.indexOf("存塘量") > -1) {
                this.storage.series.push({
                  name: re.legendName,
                  data:
                    (re.dataList &&
                      re.dataList.map((sub) => {
                        return sub.yAxisValue;
                      })) ||
                    [],
                  type: "bar",
                  xAxisIndex: 2,
                  yAxisIndex: 2,
                  barMaxWidth: "5",
                  barGap: 3,
                  animationEasing: "elasticOut",
                  itemStyle: {
                    color: new $echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      { offset: 1, color: colors[i][0] },
                      { offset: 0, color: colors[i][1] },
                    ]),
                    barBorderRadius: 50,
                  },
                  emphasis: {
                    itemStyle: {
                      color: new $echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        { offset: 1, color: colors[i][0] },
                        { offset: 0, color: colors[i][1] },
                      ]),
                    },
                  },
                });
              } else {
                this.storage.series.push({
                  name: re.legendName,
                  data:
                    (re.dataList &&
                      re.dataList.map((sub) => {
                        return sub.yAxisValue;
                      })) ||
                    [],
                  type: "bar",
                  barMaxWidth: "5",
                  barGap: 3,
                  animationEasing: "elasticOut",
                  itemStyle: {
                    color: new $echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      { offset: 1, color: colors[i][0] },
                      { offset: 0, color: colors[i][1] },
                    ]),
                    barBorderRadius: 50,
                  },
                  emphasis: {
                    itemStyle: {
                      color: new $echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        { offset: 1, color: colors[i][0] },
                        { offset: 0, color: colors[i][1] },
                      ]),
                    },
                  },
                });
              }
            }
          } else {
            /////////////////////////////////////////////
            ///////////     月存塘成本       /////////////
            /////////////////////////////////////////////
            DATA.length > 0 &&
              DATA.forEach((re, i) => {
                if (i > 2) {
                  // 随机颜色
                  let random = this.$color.getItemColors(
                    this.$color.randex(),
                    3
                  );
                  colors.push([random[0], random[random.length - 1]]);
                }
                this.storage.series.push({
                  name: re.legendName,
                  data:
                    (re.dataList &&
                      re.dataList.map((sub) => {
                        return sub.yAxisValue;
                      })) ||
                    [],
                  type: "bar",
                  barMaxWidth: "5",
                  barGap: 3,
                  itemStyle: {
                    color: new $echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      { offset: 1, color: colors[i][0] },
                      { offset: 0, color: colors[i][1] },
                    ]),
                    barBorderRadius: 50,
                  },
                  emphasis: {
                    itemStyle: {
                      color: new $echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        { offset: 1, color: colors[i][0] },
                        { offset: 0, color: colors[i][1] },
                      ]),
                    },
                  },
                });
              });
          }
          if (showBol) {
            this.showChart.unit = this.storage.unit;
            this.showChart.legend = this.storage.legend;
            this.showChart.series = this.storage.series;
            this.showChart.xAxis = this.storage.xAxis;
            this.storageChart(this.showChart, true);
            return;
          }
          this.storageChart(this.storage);
        }
      });
    },
    // 销售概览
    salesInfo: function (searchType /**指标类型 0 ~ n */, showBol) {
      salesInfo({
        orgId: this.orgId,
        type: this.type,
        year: this.year,
        month: this.month,
        breedTypeClass: this.breedTypeClass,
        searchType: searchType,
      }).then((data) => {
        if (data.code == "0000") {
          const DATA = data.data || [];
          // const DATA = require(`../../../test/president/sales/${searchType}.json`);
          this.sales.legend = [];
          this.sales.xAxis = [];
          this.sales.series = [];
          // UI默认色值
          const colors = {
            0: [
              ["#5442FF", "#907BFE"],
              ["#8540FF", "#B681FF"],
              ["#68A380", "#80B69F"],
            ],
            1: [
              ["#5442FF", "#907BFE"],
              ["#8540FF", "#B681FF"],
              ["#68A380", "#80B69F"],
            ],
            2: [["#5442FF", "#907BFE"], "#51FF98"],
          }[+searchType];
          // 赋值， 过滤数据
          this.sales.xAxis =
            (DATA.length > 0 &&
              DATA[0].dataList.map((re) => {
                return re.xAxisName;
              })) ||
            [];
          this.sales.legend =
            (DATA.length > 0 &&
              DATA.map((re) => {
                return re.legendName;
              })) ||
            [];

          if (searchType == "0") {
            /////////////////////////////////////////////
            ///////////        产值         /////////////
            /////////////////////////////////////////////
            for (let i = 0; i < DATA.length; i++) {
              const re = DATA[i];

              if (i > 2) {
                // 随机颜色
                let random = this.$color.getItemColors(this.$color.randex(), 3);
                colors.push([random[0], random[random.length - 1]]);
              }
              if (!colors[i]) {
                break;
              }
              this.sales.series.push({
                name: re.legendName,
                data:
                  (re.dataList &&
                    re.dataList.map((sub) => {
                      return sub.yAxisValue;
                    })) ||
                  [],
                type: "bar",
                barMaxWidth: "5",
                barGap: 3,
                itemStyle: {
                  color: new $echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 1, color: colors[i][0] },
                    { offset: 0, color: colors[i][1] },
                  ]),
                  barBorderRadius: 50,
                },
                emphasis: {
                  itemStyle: {
                    color: new $echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      { offset: 1, color: colors[i][0] },
                      { offset: 0, color: colors[i][1] },
                    ]),
                  },
                },
              });
            }
          } else if (searchType == "1") {
            /////////////////////////////////////////////
            ///////////        产值量        /////////////
            /////////////////////////////////////////////
            for (let i = 0; i < DATA.length; i++) {
              const re = DATA[i];
              if (i > 2) {
                // 随机颜色
                let random = this.$color.getItemColors(this.$color.randex(), 4);
                colors.push([random[0], random[random.length - 1]]);
              }
              if (!colors[i]) {
                break;
              }
              if (re.legendName.indexOf("平均单价") > -1) {
                this.sales.series.push({
                  name: re.legendName,
                  data:
                    (re.dataList &&
                      re.dataList.map((sub) => {
                        return sub.yAxisValue;
                      })) ||
                    [],
                  type: "bar",
                  barMaxWidth: "5",
                  barGap: 3,
                  animationEasing: "elasticOut",
                  itemStyle: {
                    color: new $echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      { offset: 1, color: colors[i][0] },
                      { offset: 0, color: colors[i][1] },
                    ]),
                    barBorderRadius: 50,
                  },
                  emphasis: {
                    itemStyle: {
                      color: new $echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        { offset: 1, color: colors[i][0] },
                        { offset: 0, color: colors[i][1] },
                      ]),
                    },
                  },
                });
              } else {
                this.sales.series.push({
                  name: re.legendName,
                  data:
                    (re.dataList &&
                      re.dataList.map((sub) => {
                        return sub.yAxisValue;
                      })) ||
                    [],
                  type: "bar",
                  xAxisIndex: 2,
                  yAxisIndex: 2,
                  barMaxWidth: "5",
                  barGap: 3,
                  animationEasing: "elasticOut",
                  itemStyle: {
                    color: new $echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      { offset: 1, color: colors[i][0] },
                      { offset: 0, color: colors[i][1] },
                    ]),
                    barBorderRadius: 50,
                  },
                  emphasis: {
                    itemStyle: {
                      color: new $echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        { offset: 1, color: colors[i][0] },
                        { offset: 0, color: colors[i][1] },
                      ]),
                    },
                  },
                });
              }
            }
          } else {
            /////////////////////////////////////////////
            ///////////       客户应收       /////////////
            /////////////////////////////////////////////
            for (let i = 0; i < DATA.length; i++) {
              const re = DATA[i];
              if (re.legendName == "回收率") {
                this.sales.series.push({
                  name: re.legendName,
                  data:
                    (re.dataList &&
                      re.dataList.map((sub) => {
                        return sub.yAxisValue;
                      })) ||
                    [],
                  type: "line",
                  color: colors[i],
                  smooth: true,
                  symbol: this.sales.xAxis.length > 1 ? "none" : "circle",
                  yAxisIndex: 1,
                  lineStyle: {
                    width: 1.2,
                  },
                });
              } else {
                this.sales.series.push({
                  name: re.legendName,
                  data:
                    (re.dataList &&
                      re.dataList.map((sub) => {
                        return sub.yAxisValue;
                      })) ||
                    [],
                  type: "bar",
                  barMaxWidth: "5",
                  barGap: 3,
                  itemStyle: {
                    color: new $echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      { offset: 1, color: colors[i][0] },
                      { offset: 0, color: colors[i][1] },
                    ]),
                    barBorderRadius: 50,
                  },
                  emphasis: {
                    itemStyle: {
                      color: new $echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        { offset: 1, color: colors[i][0] },
                        { offset: 0, color: colors[i][1] },
                      ]),
                    },
                  },
                });
              }
            }
          }
          if (showBol) {
            this.showChart.unit = this.sales.unit;
            this.showChart.legend = this.sales.legend;
            this.showChart.series = this.sales.series;
            this.showChart.xAxis = this.sales.xAxis;
            this.salesChart(this.showChart, true);
            return;
          }
          this.salesChart(this.sales);
        }
      });
    },
    // 单位利润计划与实际比
    prefixInfo: function (searchType /**指标类型 0 ~ n */, showBol) {
      prefixInfo({
        orgId: this.orgId,
        type: this.type,
        year: this.year,
        month: this.month,
        breedTypeClass: this.breedTypeClass,
        searchType: searchType,
      }).then((data) => {
        if (data.code == "0000") {
          const DATA = data.data || [];
          // const DATA = require(`../../../test/president/prefix/${searchType}.json`);
          this.prefix.legend = [];
          this.prefix.xAxis = [];
          this.prefix.series = [];
          // UI默认色值
          const colors = [
            ["#5442FF", "#907BFE"],
            ["#68A380", "#80B69F"],
          ];
          // 赋值， 过滤数据
          this.prefix.xAxis =
            (DATA.length > 0 &&
              DATA[0].dataList.map((re) => {
                return re.xAxisName;
              })) ||
            [];
          this.prefix.legend =
            (DATA.length > 0 &&
              DATA.map((re) => {
                return re.legendName;
              })) ||
            [];
          for (let i = 0; i < DATA.length; i++) {
            if (i > 1) {
              // 随机颜色
              let random = this.$color.getItemColors(this.$color.randex(), 3);
              colors.push([random[0], random[random.length - 1]]);
            }
            if (!colors[i]) {
              break;
            }
            const re = DATA[i];
            this.prefix.series.push({
              name: re.legendName,
              data:
                (re.dataList &&
                  re.dataList.map((sub) => {
                    return sub.yAxisValue;
                  })) ||
                [],
              type: "bar",
              barMaxWidth: "5",
              barGap: 3,
              itemStyle: {
                color: new $echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 1, color: colors[i][0] },
                  { offset: 0, color: colors[i][1] },
                ]),
                barBorderRadius: 50,
              },
              emphasis: {
                itemStyle: {
                  color: new $echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 1, color: colors[i][0] },
                    { offset: 0, color: colors[i][1] },
                  ]),
                },
              },
            });
          }
          if (showBol) {
            this.showChart.unit = this.prefix.unit;
            this.showChart.legend = this.prefix.legend;
            this.showChart.series = this.prefix.series;
            this.showChart.xAxis = this.prefix.xAxis;
            this.prefixChart(this.showChart, true);
            return;
          }
          this.prefixChart(this.prefix);
        }
      });
    },
    // 成本概览
    costInfo: function () {
      costInfo({
        orgId: this.orgId,
        type: this.type,
        year: this.year,
        month: this.month,
        breedTypeClass: this.breedTypeClass,
      }).then((data) => {
        if (data.code == "0000") {
          const DATA = data.data || [];
          // const DATA = require(`../../../test/president/cost/0.json`);
          this.cost.legend = [];
          this.cost.xAxis = [];
          this.cost.series = [];
          // UI默认色值
          const colors = [
            ["#5442FF", "#907BFE"],
            ["#8540FF", "#B681FF"],
            ["#68A380", "#80B69F"],
          ];
          // 赋值， 过滤数据
          this.cost.xAxis =
            (DATA.length > 0 &&
              DATA[0].dataList.map((re) => {
                return re.xAxisName;
              })) ||
            [];
          this.cost.legend =
            (DATA.length > 0 &&
              DATA.map((re) => {
                return re.legendName;
              })) ||
            [];
          DATA.length > 0 &&
            DATA.forEach((re, i) => {
              if (i > 2) {
                // 随机颜色
                let random = this.$color.getItemColors(this.$color.randex(), 3);
                colors.push([random[0], random[random.length - 1]]);
              }
              this.cost.series.push({
                name: re.legendName,
                data:
                  (re.dataList &&
                    re.dataList.map((sub) => {
                      return sub.yAxisValue;
                    })) ||
                  [],
                type: "bar",
                barMaxWidth: "5",
                barGap: 3,
                itemStyle: {
                  color: new $echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 1, color: colors[i][0] },
                    { offset: 0, color: colors[i][1] },
                  ]),
                  barBorderRadius: 50,
                },
                emphasis: {
                  itemStyle: {
                    color: new $echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      { offset: 1, color: colors[i][0] },
                      { offset: 0, color: colors[i][1] },
                    ]),
                  },
                },
              });
            });
          this.costChart(this.cost);
        }
      });
    },
    // 收获概览
    harvestInfo: function (searchType /**指标类型 0 ~ n */, showBol) {
      harvestInfo({
        orgId: this.orgId,
        type: this.type,
        year: this.year,
        month: this.month,
        breedTypeClass: this.breedTypeClass,
        searchType: searchType,
      }).then((data) => {
        if (data.code == "0000") {
          const DATA = data.data || [];
          // const DATA = require(`../../../test/president/harvest/${searchType}.json`);
          this.harvest.legend = [];
          this.harvest.xAxis = [];
          this.harvest.series = [];
          // UI默认色值
          const colors = [
            ["#5442FF", "#907BFE"],
            ["#8540FF", "#B681FF"],
            ["#68A380", "#80B69F"],
          ];
          // 赋值， 过滤数据
          this.harvest.xAxis =
            (DATA.length > 0 &&
              DATA[0].dataList.map((re) => {
                return re.xAxisName;
              })) ||
            [];
          this.harvest.legend =
            (DATA.length > 0 &&
              DATA.map((re) => {
                return re.legendName;
              })) ||
            [];
          if (searchType == "0") {
            /////////////////////////////////////////////
            ///////////        产量         /////////////
            /////////////////////////////////////////////
            for (let i = 0; i < DATA.length; i++) {
              const re = DATA[i];
              if (i > 2) {
                // 随机颜色
                let random = this.$color.getItemColors(this.$color.randex(), 4);
                colors.push([random[0], random[random.length - 1]]);
              }
              if (!colors[i]) {
                break;
              }
              if (re.legendName.indexOf("每公斤出苗量") > -1) {
                this.harvest.series.push({
                  name: re.legendName,
                  data:
                    (re.dataList &&
                      re.dataList.map((sub) => {
                        return sub.yAxisValue;
                      })) ||
                    [],
                  type: "bar",
                  barMaxWidth: "5",
                  barGap: 3,
                  animationEasing: "elasticOut",
                  itemStyle: {
                    color: new $echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      { offset: 1, color: colors[i][0] },
                      { offset: 0, color: colors[i][1] },
                    ]),
                    barBorderRadius: 50,
                  },
                  emphasis: {
                    itemStyle: {
                      color: new $echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        { offset: 1, color: colors[i][0] },
                        { offset: 0, color: colors[i][1] },
                      ]),
                    },
                  },
                });
              } else {
                this.harvest.series.push({
                  name: re.legendName,
                  data:
                    (re.dataList &&
                      re.dataList.map((sub) => {
                        return sub.yAxisValue;
                      })) ||
                    [],
                  type: "bar",
                  xAxisIndex: 2,
                  yAxisIndex: 2,
                  barMaxWidth: "5",
                  barGap: 3,
                  animationEasing: "elasticOut",
                  itemStyle: {
                    color: new $echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      { offset: 1, color: colors[i][0] },
                      { offset: 0, color: colors[i][1] },
                    ]),
                    barBorderRadius: 50,
                  },
                  emphasis: {
                    itemStyle: {
                      color: new $echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        { offset: 1, color: colors[i][0] },
                        { offset: 0, color: colors[i][1] },
                      ]),
                    },
                  },
                });
              }
            }
          } else {
            /////////////////////////////////////////////
            ///////////     塘口收获情况     /////////////
            /////////////////////////////////////////////
            for (let i = 0; i < DATA.length; i++) {
              if (i > 1) {
                // 随机颜色
                let random = this.$color.getItemColors(this.$color.randex(), 3);
                colors.push([random[0], random[random.length - 1]]);
              }
              if (!colors[i]) {
                break;
              }
              const re = DATA[i];
              this.harvest.series.push({
                name: re.legendName,
                data:
                  (re.dataList &&
                    re.dataList.map((sub) => {
                      return sub.yAxisValue;
                    })) ||
                  [],
                type: "bar",
                barMaxWidth: "5",
                barGap: 3,
                itemStyle: {
                  color: new $echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 1, color: colors[i][0] },
                    { offset: 0, color: colors[i][1] },
                  ]),
                  barBorderRadius: 50,
                },
                emphasis: {
                  itemStyle: {
                    color: new $echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      { offset: 1, color: colors[i][0] },
                      { offset: 0, color: colors[i][1] },
                    ]),
                  },
                },
              });
            }
          }
          if (showBol) {
            this.showChart.unit = this.harvest.unit;
            this.showChart.legend = this.harvest.legend;
            this.showChart.series = this.harvest.series;
            this.showChart.xAxis = this.harvest.xAxis;
            this.harvestChart(this.showChart, true);
            return;
          }
          this.harvestChart(this.harvest);
        }
      });
    },
    // 指标概览
    quotaInfo: function (searchType /**指标类型 0 ~ n */, showBol) {
      quotaInfo({
        orgId: this.orgId,
        type: this.type,
        year: this.year,
        month: this.month,
        breedTypeClass: this.breedTypeClass,
        searchType: searchType,
      }).then((data) => {
        if (data.code == "0000") {
          const DATA = data.data || [];
          // const DATA = require(`../../../test/president/quota/${searchType}.json`);
          this.quota.legend = [];
          this.quota.xAxis = [];
          this.quota.series = [];
          // UI默认色值
          let colors = {
            // "stackId":["#5442FF", "#A291FD"],
            // "stackId":["#8540FF", "#C092FF"],
            // "stackId":["#5E9876", "#90C7AF"],
          };
          // 赋值， 过滤数据
          this.quota.xAxis =
            (DATA.length > 0 &&
              DATA[0].dataList.map((re) => {
                return re.xAxisName;
              })) ||
            [];
          this.quota.legend =
            (DATA.length > 0 &&
              DATA.map((re) => {
                return re.legendName;
              })) ||
            [];

          var emphasisStyle = {
            focus: "series",
            itemStyle: {
              shadowBlur: 10,
              shadowColor: "rgba(0,0,0,0.3)",
            },
          };
          for (let i = 0; i < DATA.length; i++) {
            const re = DATA[i];

            if (!colors[re.stackId]) {
              let count = 0;
              for (const key in colors) {
                count++;
              }
              if (count >= 3) {
                let random = this.$color.getItemColors(this.$color.randex(), 4);
                colors[re.stackId] = [random[0], random[random.length - 1]];
              } else if (count == 2) {
                colors[re.stackId] = ["#5E9876", "#90C7AF"];
              } else if (count == 1) {
                colors[re.stackId] = ["#8540FF", "#C092FF"];
              } else if (count == 0) {
                colors[re.stackId] = ["#5442FF", "#A291FD"];
              }
              // 赋值
              this.quota.series.push({
                name: re.legendName,
                type: "bar",
                stack: re.stackId,
                data:
                  (re.dataList &&
                    re.dataList.map((sub) => {
                      return sub.yAxisValue;
                    })) ||
                  [],
                barMaxWidth: "6",
                barGap: 1,
                itemStyle: {
                  color: colors[re.stackId][0],
                  barBorderRadius: [0, 0, 50, 50],
                },
                emphasis: emphasisStyle,
              });
            } else {
              this.quota.series.push({
                name: re.legendName,
                type: "bar",
                stack: re.stackId,
                data:
                  (re.dataList &&
                    re.dataList.map((sub) => {
                      return sub.yAxisValue;
                    })) ||
                  [],
                itemStyle: {
                  color: colors[re.stackId][1],
                  barBorderRadius: [50, 50, 0, 0],
                },
                emphasis: emphasisStyle,
              });
            }
          }
          if (showBol) {
            this.showChart.unit = this.harvest.quota;
            this.showChart.legend = this.quota.legend;
            this.showChart.series = this.quota.series;
            this.showChart.xAxis = this.quota.xAxis;
            this.quotaChart(this.quota, true);
            return;
          }
          this.quotaChart(this.quota);
        }
      });
    },
    // 汇总数据
    totalDataInfo: function () {
      totalDataInfo({
        orgId: this.orgId,
        type: this.type,
        year: this.year,
        month: this.month,
        breedTypeClass: this.breedTypeClass,
      }).then((data) => {
        if (data.code == "0000") {
          this.totalData = data.data;
        }
      });
    },
  },
  beforeMount() {
    // 模板编译/挂载之前
  },
  mounted() {
    // 模板编译/挂载之后
    this.annalsTargetChart(this.annalsTarget);
    this.putChart(this.put);
    this.storageChart(this.storage);
    this.salesChart(this.sales);
    this.prefixChart(this.prefix);
    this.costChart(this.cost);
    this.harvestChart(this.harvest);
    this.quotaChart(this.quota);
  },
  created() {
    this.type = this.app.dateType == "year" ? "Y" : "M";
    (this.type == "Y" && (this.year = this.app.date)) ||
      (this.month = this.app.date);
    this.orgId = localStorage.getItem("rootId");

    this.totalDataInfo();

    // 获取图标数据
    this.annalsTargetInfo(this.annalsTarget.searchType);
    this.putInfo(this.put.searchType);
    this.storageInfo(this.storage.searchType);
    this.salesInfo(this.sales.searchType);
    this.prefixInfo(this.prefix.searchType);
    this.costInfo();
    this.harvestInfo(this.harvest.searchType);
    this.quotaInfo(this.quota.searchType);

    // echart自适应
    // debounce函数让一个方法在一定时间内只能执行一次
    this.resizeHandler = debounce(
      () => {
        this.annalsTarget.chartDom && this.annalsTarget.chartDom.resize();
        this.put.chartDom && this.put.chartDom.resize();
        this.storage.chartDom && this.storage.chartDom.resize();
        this.sales.chartDom && this.sales.chartDom.resize();
        this.prefix.chartDom && this.prefix.chartDom.resize();
        this.cost.chartDom && this.cost.chartDom.resize();
        this.harvest.chartDom && this.harvest.chartDom.resize();
        this.quota.chartDom && this.quota.chartDom.resize();
      },
      100,
      false
    );
    // 监听浏览器窗口页面
    window.addEventListener("resize", this.resizeHandler);
  },
  beforeUpdate() {
    // 组件更新之前
  },
  updated() {
    // 组件更新之后
  },
  beforeDestroy() {
    // 组件销毁前调用
    // Tips：你确认删除XX吗？
  },
  destroyed() {
    // 组件销毁后调用
    // Tips：当前组件已被删除，清空相关内容
  },
  // 数据监听
  watch: {
    dateType: function (value) {
      this.type = value == "year" ? "Y" : "M";
    },
    date: function (value, old) {
      if (/^\d{4}$/.test(value)) {
        this.year = value;
      } else if (/^\d{4}-((0([1-9]))|(1(0|1|2)))$/.test(value)) {
        this.month = value;
      }
      this.orgId = localStorage.getItem("rootId");
      // 获取图标数据
      this.annalsTargetInfo(this.annalsTarget.searchType);
      this.putInfo(this.put.searchType);
      this.storageInfo(this.storage.searchType);
      this.salesInfo(this.sales.searchType);
      this.prefixInfo(this.prefix.searchType);
      this.costInfo();
      this.harvestInfo(this.harvest.searchType);
      this.quotaInfo(this.quota.searchType);
      this.totalDataInfo();
    },
  },
};
</script>

<style lang="less" scoped>
.content-box {
  width: 100%;
  min-height: 940px;
  height: auto;
  overflow-y: hidden;
  display: flex;
  background: #181a1f;

  // 布局样式
  >div {
    // 去除左右两边外间距和盒子的外间距
    width: calc((100% - 7px - 7px - 7px - 7px) / 3);

    &:first-child {
      margin-left: 7px;
    }

    &:not(:first-child) {
      margin-left: 7px;
    }

    // 盒子样式
    .sub-box {
      width: 100%;
      height: 304.33px;
      background: #1e1e2b;
      border: 1px solid #34324d;
      box-sizing: border-box;

      &:first-child {
        margin-top: 7px;
      }

      &:not(:first-child) {
        margin-top: 7px;
      }

      &:last-child {
        margin-bottom: 7px;
      }

      // 盒子标题
      .big-title {
        height: auto;
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        display: inline-block;
        position: relative;
        width: 100%;

        >span {
          position: relative;
          margin-left: 30px;
          margin-top: 7px;
          display: inline-block;

          &::after {
            position: absolute;
            content: "";
            width: 4px;
            height: 17px;
            background: #8631f0;
            border-radius: 4px 0px 4px 0px;
            top: 6px;
            left: -10px;
          }
        }

        // 查看更多
        .title-right {
          display: inline-block;
          position: absolute;
          top: 7px;
          right: 22px;

          span {
            font-size: 12px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #d7d7d9;

            >i {
              font-size: 13px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #d7d7d9;
            }
          }
        }
      }

      // 图表盒子
      .chart-content {
        width: 100%;
        height: calc(100% - 33px);
        position: relative;

        // 图表选项
        .sub-titles {
          position: absolute;
          top: 14px;
          left: 30px;
          z-index: 0;

          >span {
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #ffffff;
            cursor: pointer;
            padding: 6px 14px;

            >span {}
          }

          .sub-active {
            display: inline-block;
            background: linear-gradient(90deg, #ab19f7 0%, #15a8c2 100%);
            border-radius: 14px;
          }
        }

        .chart-empty {
          position: absolute;
          top: 0;
          bottom: 0;
          z-index: 9;
          height: calc(100% - 45px) !important;
          margin-top: 45px !important;
        }
      }
    }

    .sub-box-middle {
      height: 402.5px;
    }

    // 顶部数字盒子
    .num-box {
      display: flex;
      justify-content: space-between;
      margin-top: 7px;

      >span {
        display: inline-block;
        width: 152px;
        height: 107px;
        background: #5442ff;
      }

      .count-txt {
        display: inline-block;
        height: 15px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        width: 100%;
        text-align: center;
      }
    }
  }
}

// 1920分辨率，盒子高度作改变

// 1366分辨率，盒子高度作改变
</style>
